export type GlobalDialogProps = {
  data: DialogChildren;
  hideDialog: () => void;
};

export type StaticPageProps = {
  showDialog: (targetUrl: string) => void;
};

export type CashPayTodayAcknowledgementProps = {
  expanded: boolean;
  currentDialog: DialogChildren;
  globalLanguage: string;
  showDialog: (dialogConfig: GlobalDialog) => void;
  showLeaveDialog: (url: string) => void;
}

export type CashPayTodaySMMProps = {
  expanded: boolean;
}


export type GlobalDialog = {
  children: DialogChildren;
};

export type DialogChildren = {
  title: string;
  subtitle: string;
  content: string;
  open: boolean;
  onClose?: () => {};
  cancelButton?: DialogButton;
  affirmativeButton: DialogButton;
  replaceId?: string;
  replaceContent?: JSX.Element;
  persistOnButton?: boolean;
  dialogContentStyling?: Object;
  hideActionBar?: boolean;
};

export type DialogContentElement = {
  bodyType: "_validationEmailSent_";
};

export type DialogButton = {
  color:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  caption: string;
  onClickMethod?: any;
  variant?: "contained" | "outlined" | "text";
  whitespace?: string;
};

export const LeaveSiteNoLogoutDialog: DialogChildren = {
  open: true,
  title: "NOTICE",
  subtitle: "",
  content: `<p>You are about to leave this website.  Do you want to continue?</p>`,
  cancelButton: { color: "primary", caption: "Cancel" },
  affirmativeButton: { color: "primary", caption: "Continue" },
};

export const SessionTimeoutDialog: DialogChildren = {
  open: true,
  title: "SESSION EXPIRATION",
  subtitle: "",
  content: `<p style="text-align: center">Your session is about to expire. Do you want to Logoff?</p>`,
  cancelButton: { color: "primary", caption: "No" },
  affirmativeButton: { color: "primary", caption: "Yes" },
};
export const AccountEntryCancelDialog: DialogChildren = {
  open: true,
  title: "DISCARD CHANGES?",
  subtitle: "",
  content: `<p style="text-align: center">Changes you made will not be saved.</p>`,
  cancelButton: { color: "primary", caption: "STAY" },
  affirmativeButton: { color: "primary", caption: "DISCARD" },
};

export const PersonaFailurePartOneDialog: DialogChildren = {
  open: true,
  title: "INVALID INFO DETECTED",
  subtitle: "",
  content: `<p style="text-align: left;">
  Please review the information you provided to ensure accuracy and completeness. Required information 
  below:
  </p>
  <ul>
  <li>Full Legal name</li>
  <li>A valid US-based landline or cellphone (non-internet call), that can be validated</li>
  <li>A valid physical address recognized by the United States Postal Service,
  including unit numbers and zip code</li>
  <li>Complete and accurate date of birth</li>
  <li>Valid email (non-disposable), temporary email accounts not allowed</li>
  </ul>`,
  cancelButton: {color: "primary", variant: "outlined", caption: "LEARN MORE"},
  affirmativeButton: { color: "primary", variant: "outlined", caption: "OK" },
};


export const PersonaFailurePartTwoDialog: DialogChildren = {
  open: true,
  title: "INVALID INFO DETECTED",
  subtitle: "",
  content: `<p style="text-align: left;">
  To assist with the detection and prevention of fraud and other financial crimes, 
  Access Corrections is taking additional steps to verify the information provided by its customers. 
  </p>
  <p style="text-align: left;">
  Please review the information you provided to ensure accuracy and completeness.
  </p>`,
  cancelButton: {color: "primary", variant: "outlined", caption: "LEARN MORE"},
  affirmativeButton: { color: "primary", variant: "outlined", caption: "OK" },
};


export const MyAccountSecurityDialog: DialogChildren = {
  open: true,
  title: "ACCOUNT SECURITY",
  subtitle: "",
  content: "",
  cancelButton: { color: "primary", caption: "Cancel" },
  affirmativeButton: { color: "primary", caption: "OK" },
};

export const EmailVerificationDialog: DialogChildren = {
  open: true,
  title: "Validation Email Sent",
  subtitle: "This link will expire in 30 minutes.",
  content: `<p>
  We have sent an email to the address you provided.
  Please click the link in that message to validate and fully activate your account.
  </p>
  Didn't receive it?
  <ul class="globalDialogContentUL">
  <li>Check your junk/spam folder</li>
  <li>Mark this email as a safe sender noreply@accesscorrections.com</li>
  <li>Go to your Dashboard and resend it.</li>
  </ul>`,
  affirmativeButton: { color: "primary", caption: "CONTINUE" },
};

export const RemoveResidentDialog: DialogChildren = {
  open: true,
  title: "REMOVE RECIPIENT",
  subtitle: "",
  content: `<p style="text-align: center">Are you sure you want to remove this recipient?</p>`,
  cancelButton: { color: "primary", caption: "CANCEL" },
  affirmativeButton: { color: "primary", caption: "REMOVE" },
};

export const DashboardAccountVerificationDialog: DialogChildren = {
  open: true,
  title: "ACCOUNT VERIFICATION Required",
  subtitle: "",
  content: `<p>Email verification is required to send funds. Check your email for the verification instructions. 
  Don't see the email? Check your junk/spam folder, make sure your email address is correct in your account, or try resending it.</p>`,
  cancelButton: { color: "primary", caption: "CLOSE" },
  affirmativeButton: { color: "primary", caption: "RESEND VERIFICATION" },
};

export const RecentTransactionNotice: DialogChildren = {
  open: true,
  title: "RECENT TRANSACTION NOTICE",
  subtitle: "",
  content: `
  <p class='dialogContentWarning'>This transaction will not be refundable.</p>
  <p>We noticed you made a recent transaction. Please review the information regarding the previous transaction below before continuing.</p>`,
  cancelButton: { color: "primary", caption: "CANCEL" },
  affirmativeButton: { color: "primary", caption: "CONTINUE" },
};

export const CheckoutIssueDialog: DialogChildren = {
  open: true,
  title: "Issue with processing your payment",
  subtitle: "",
  content: `<p id="recipientHistoryContentReplace">There was an issue processing your payment. Please try again later.</p>`,
  affirmativeButton: {
    color: "primary",
    caption: "CLOSE",
  },
};

export const RecipientHistoryDialog: DialogChildren = {
  open: true,
  title: "TRANSACTION HISTORY",
  subtitle: "",
  content: `<p id="recipientHistoryContentReplace">TEST</p>`,
  affirmativeButton: {
    color: "primary",
    caption: "CLOSE",
  },
};
export const RecipientChargebackDialog: DialogChildren = {
  open: true,
  title: "RESTRICTION",
  subtitle: "",
  content: "",
  affirmativeButton: { color: "primary", caption: "OK", variant: "contained" },
};

export const UnapprovedDepositorDialog: DialogChildren = {
  open: true,
  title: "UNAPPROVED DEPOSITOR",
  subtitle: "",
  content:
    "<p>You are not an approved depositor for this recipient. Please contact the recipient to get on their approved depositor list.<p>",
  affirmativeButton: { color: "primary", caption: "OK", variant: "outlined" },
};

export const AnchorClickUserAgreementDialogEnglish: DialogChildren = {
  open: true,
  title: "USER AGREEMENT",
  subtitle: "",
  replaceId: "replaceId",
  content: `
  <div id="replaceId">
    <h1>User Agreement</h1>
  </div>
  <div className="centered">
    <hr />
  </div>
  <p>
    <strong>Note: </strong>The User Agreement below will take immediate
    effect for all registered CyberSuite Correctional Services Users now
    known as Access Corrections Users, effective January 3, 2023. Access
    Corrections reserves the right at its discretion to change the terms of
    this User Agreement with or without notice. Your continued use of the
    Access Corrections website, Access Secure Deposit kiosk, Access Secure
    Deposit by phone, Access Secure Mail or any other Access Corrections
    service shall constitute your explicit agreement with the then current
    User Agreement and any other document referenced by the User Agreement.
  </p>
    <h2>User Agreement</h2>
  <p>
    This User Agreement ("Agreement") is a contract between you and Access
    Corrections and applies to your use of the Access Corrections inmate
    deposit service, Secure Mail and any other related services
    (collectively the "Service"). This Agreement affects your rights and you
    should read it carefully. For additional information about the Service
    and how it works, please consult the Access Corrections website at
    <a class="ot-btn-anchor" href="http://www.accesscorrections.com/v2/home">
      http://www.accesscorrections.com/v2/home
    </a>
    or contact an Access Corrections customer service representative at
    <a class="ot-btn-anchor" href="mailto:customerservice@accesscorrections.com">
      customerservice@accesscorrections.com
    </a>
    or 1-866-345-1884.
  </p>

  <h2>Notice</h2>

  <p>
    By clicking "I Agree", "I Accept", or other similar text; or by
    submitting payment information through the Service you agree to the
    terms and conditions of this Agreement, the Access Corrections Privacy
    Policy, the Access Corrections Terms and Conditions of Use, and any
    documents incorporated by reference. You further agree that this
    Agreement forms a legally binding contract between you and Access
    Corrections, and that this Agreement constitutes a writing signed by you
    under any applicable law or regulation. Any rights not expressly granted
    herein are reserved by Access Corrections. This Agreement is subject to
    change by Access Corrections without prior notice (unless prior notice
    is required by law), by posting of the revised Agreement on the Access
    Corrections website or Secure Deposit kiosk. In this Agreement, "You", " “User” or “Customer”
    means any person or entity using the Service.
  </p>

  <h2>The Access Corrections Service</h2>

  <p>
    An Access Corrections Secure Deposits User may send funds (the
    "Payment") to an Access Corrections Client (i.e. the correctional
    institution receiving funds on behalf of the inmate) in the United
    States over the Internet using a U.S. issued Visa or MasterCard credit
    card, or a Visa or MasterCard branded debit card (collectively "Bank
    Card"). Correctional agency staff has the authority to review, approve
    and reject all incoming payments. An Access Corrections Secure Mail User
    may send messages (the “Email”) to an Access Corrections Client (i.e.
    the correctional institution receiving electronic messages on behalf of
    the inmate) in the United States over the Internet using a U.S. issued
    Visa or MasterCard credit card, or a Visa or MasterCard branded debit
    card (collectively “Bank Card”). Correctional agency staff has the
    authority to review, approve and reject all incoming messages. When
    required by applicable law, payments will be reported to federal, state
    or local authorities. You will be required to provide Access Corrections
    with certain information to allow us, among other things: to verify your
    identity; to receive appropriate Bank Card authorization; and any other
    information Client shall require to send the Payment or Mail. Please
    refer to Access Corrections Privacy Policy for information concerning
    Access Corrections use of this information.
  </p>

  <h2>Agency Access</h2>

  <p>
    User must agree that the correctional agency staff has the authority to
    review, approve and reject all incoming payments and emails delivered by
    Access Corrections. If agency staff deems an email inappropriate it will
    reject delivery of the email to the designated inmate. No refunds will
    be given for emails deemed inappropriate by agency staff. All users of
    Access Corrections must be aware that all information, including but not
    limited to, payment, email, name and address is accessible by agency
    staff for review and approval. All users of Access Corrections
    acknowledge that correctional agency staff has the approval to use any
    and all information transmitted through Access Corrections for
    investigative and legal purposes. Information transmitted through Access
    Corrections can be used and distributed by personnel involved in the
    correctional industry, investigative (public and private) or public
    safety purposes, specifically the Department of Homeland Security and
    any other anti-terrorist agency (collectively “Law Enforcement”)
  </p>

  <h2>OREGON DEPARTMENT OF CORRECTIONS USERS</h2>

  <p>
    The Oregon Department of Corrections restricts the contents of incoming
    and outgoing messages to inmates. Language that is sexually explicit is
    forbidden and will result in rejection of your message. Material that
    might cause a security concern or program concern is forbidden and will
    be rejected. Photographs displaying human genitalia or photographs
    capturing or promoting criminal activity will be rejected. These
    restrictions are based on criteria found in the Oregon Administrative
    Rule, Division 291-131, Rule on Mail (Inmate). You may find the Mail
    Rule by visiting the Oregon Department of Corrections website.
  </p>

  <h2>POLK COUNTY, FL USERS</h2>

  <p>
    If the resident owes the facility restitution for any fees or fines, it
    will be deducted from the deposits made prior to being deposited in the
    resident's account. Please call the facility for information on any debts
    owed.
  </p>

  <h2>Fees</h2>

  <p>
    In consideration for the use of the Service, you agree to pay Access
    Corrections a fee for each Payment or Email sent by you at the
    applicable rate then in effect (the "Service Fee"). The applicable
    Service Fee for your Payment will be provided to you prior to your final
    authorization of the Payment, in addition to any applicable fees for
    additional services. All Service Fees are non-refundable.
  </p>

  <h2>Payment</h2>

  <p>
    Service Fees and the Payment amount are due and payable before Access
    Corrections processes the Payment or sends the Email. You must pay for
    the Service by Bank Card. If Access Corrections does not receive
    authorization from the card issuer, the Payment will not be processed
    and funds will not be transmitted to the Client and/or email credits
    will not be received. Each time you use the Service you agree that
    Access Corrections is authorized to charge your designated Bank Card
    account for the principal Payment amount, the Service Fee, and any other
    applicable fees. (Your agreement with your card issuer governs use of
    your card, and you must refer to that agreement to ascertain your rights
    and liabilities as a cardholder, which may include a “cash advance”
    fee.)
  </p>

  <h2>Disputes</h2>

  <p>
    This User Agreement shall be governed by and construed in accordance
    with the laws of the State of Missouri, United States of America,
    without regard to its conflict of law principles. Any action to enforce
    this User Agreement shall be brought in the federal court in the Eastern
    District of Missouri or the state courts located in St. Louis County,
    Missouri. By using the Service, you consent to the jurisdiction and
    venue of these courts. Except where prohibited, you agree that any and
    all disputes, claims and causes of action directly or indirectly arising
    out of use of the Service shall be resolved individually, without resort to any
    form of class action. Any claim or cause of action you may have with
    respect to the User Agreement must be commenced within one (1) year
    after the claim or cause of action arises, regardless of any law to the
    contrary.
  </p>

  <h2>General</h2>

  <p>
    If any provision of this User Agreement is held to be invalid or
    unenforceable, that provision shall be construed consistent with
    applicable law, and the remaining provisions shall be enforced. Headings
    are for reference purposes only and in no way define, limit, construe or
    describe the scope of such section. Our failure to enforce any provision
    of this User Agreement shall not constitute a waiver of that or any
    other provision. This User Agreement and the documents incorporated by
    reference, sets forth the entire agreement between you and Access
    Corrections in connection with your use of the Service.
  </p>

  <h2>DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</h2>

  <p>
    THE ACCESS CORRECTIONS SITE AND KIOSK INTERFACE (COLLECTIVELY THE “SERVICE PLATFORM”) ARE
    PROVIDED BY ACCESS CORRECTIONS ON AN "AS IS" AND "AS AVAILABLE" BASIS. ACCESS CORRECTIONS
    MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE
    OPERATION OF THE SERVICE PLATFORM OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS OR
    SERVICES INCLUDED ON THE SITE OR KIOSK INTERFACE. YOU EXPRESSLY AGREE THAT YOUR USE OF THE
    SERVICE PLATFORM IS AT YOUR SOLE RISK AND THAT YOU ARE SOLELY RESPONSIBLE FOR THE
    ACCURACY OF THE PERSONAL AND PAYMENT INFORMATION THAT YOU PROVIDE. TO THE FULL EXTENT
    PERMISSIBLE BY APPLICABLE LAW, ACCESS CORRECTIONS DISCLAIMS ALL WARRANTIES, EXPRESS OR
    IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
    FOR A PARTICULAR PURPOSE. ACCESS CORRECTIONS DOES NOT WARRANT THAT THE SITE OR KIOSK
    INTERFACE, ITS SERVICES OR E-MAIL SENT FROM ACCESS CORRECTIONS ARE FREE OF VIRUSES OR
    OTHER HARMFUL COMPONENTS.
  </p>

  <p>
    ACCESS CORRECTIONS (AS WELL AS ITS OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES AND
    STOCKHOLDERS) WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS
    SITE, ANY CREDIT CARD COMPANY'S NON-AUTHORIZATION OF A USER'S BANK CARD PAYMENT, FOR
    DISRUPTIONS IN THE SERVICE PLATFORM, OR FOR ERROR, DELAY OR MIS-DELIVERY OF A PAYMENT,
    REGARDLESS OF THE CAUSE, INCLUDING (WITHOUT LIMITATION) DIRECT, INDIRECT, INCIDENTAL,
    PUNITIVE AND CONSEQUENTIAL DAMAGES.
  </p>

  <p>
    CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE
    EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU,
    SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS OR LIMITATIONS MAY NOT
    APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS.
  </p>

  <h2>Help Prevent Consumer Fraud! </h2>

  <h3 className="a11y">
    Are you sending money to someone you don’t know or whose identity you
    can’t verify?
  </h3>

  <h3 className="a11y">
    Are you responding to an Internet or phone offer that you aren’t sure is
    honest?
  </h3>

  <h3 className="a11y">
    Are you sending money because you were “guaranteed” a credit card or
    loan?
  </h3>

  <p>
    <strong>
      If so, please call 1-866-345-1884 and ask an Access Corrections Call
      Center Representative to stop your transfer immediately.
    </strong>
  </p>`,
  affirmativeButton: { color: "primary", caption: "Close" },
};

export const AnchorClickUserAgreementDialogSpanish: DialogChildren = {
  open: true,
  title: "ACUERDO DEL USUARIO",
  subtitle: "",
  replaceId: "replaceId",
  content: `<div id="replaceId">
  <h1>ACUERDO DEL USUARIO</h1>
</div>
<div className="centered">
  <hr />
</div>
<p>
  <strong>Nota: </strong>El Acuerdo del usuario que sigue a continuación
      entrará en vigencia de inmediato para todos los usuarios registrados de
      CyberSuite Correctional Services, ahora conocidos como "Usuarios de
      Access Corrections", a partir del 3 de enero de 2023. Access Corrections
      se reserva el derecho a cambiar los términos de este Acuerdo del usuario
      con o sin previo aviso por decisión propia. El uso continuo del sitio
      web de Access Corrections, las cabinas de Access Secure Deposit, Access
      Secure Deposit vía telefónica, Access Secure Mail o cualquier otro
      servicio de Access Corrections constituye la aceptación explícita del
      Acuerdo del usuario actual y de cualquier otro documento al que se haga
      referencia en el Acuerdo del usuario.
</p>
  <h2>Acuerdo del usuario</h2>
<p>
 Este Acuerdo del usuario (el "Acuerdo") es un contrato entre usted y
        Access Corrections, y se aplica al uso que usted le dé al servicio de
        depósito al interno de Access Corrections, a Secure Mail y a otros
        servicios afines (conjuntamente, el "Servicio"). El presente Acuerdo
        afecta sus derechos, por eso, debe leerlo cuidadosamente. Para obtener
        información adicional acerca del Servicio y de cómo funciona, consulte
        el sitio web de Access Corrections en
  <a class="ot-btn-anchor" href="http://www.accesscorrections.com/v2/home">
    http://www.accesscorrections.com/v2/home
  </a>
  o póngase en contacto con un representante del servicio de atención al
        cliente de Access Corrections a{"
  <a class="ot-btn-anchor" href="mailto:customerservice@accesscorrections.com">
    customerservice@accesscorrections.com
  </a>
  o al 1-866-345-1884.
</p>

<h2>Aviso</h2>

<p>
   Al hacer clic en "Estoy de acuerdo", "Acepto" o cualquier otro texto
        similar; o al introducir la información de pago a través del Servicio,
        usted acepta los términos y condiciones del presente Acuerdo, la
        política de privacidad de Access Corrections, los Términos y
        condiciones de uso de Access Corrections y cualquier documento
        incorporado por referencia. Asimismo, acepta que este Acuerdo
        constituye un contrato legalmente vinculante entre usted y Access
        Corrections, y que este Acuerdo constituye un escrito firmado por
        usted bajo cualquier ley o normativa aplicable. Todos los derechos no
        expresamente concedidos aquí son reservados por Access Corrections.
        Este Acuerdo está sujeto a cambios por parte de Access Corrections sin
        previo aviso (salvo que la ley exija que se notifiquen con antelación)
        mediante la publicación del Acuerdo revisado en el sitio web de Access
        Corrections o en las cabinas de Secure Deposit. En este Acuerdo,
        "usted", "Usuario" o "Cliente" hacen referencia a cualquier persona o
        entidad que utilice el Servicio.
</p>

<h2>El servicio de Access Corrections</h2>

<p>
   Un Usuario de Access Corrections Secure Deposit puede enviar fondos
        (el "Pago") a un Cliente de Access Corrections (es decir, la
        institución correccional que recibe los fondos en nombre del interno)
        en los Estados Unidos a través de Internet utilizando una tarjeta de
        crédito o débito Visa o MasterCard emitida en los Estados Unidos
        (conjuntamente, la "Tarjeta bancaria"). El personal de la agencia
        correccional tiene la facultad de revisar, aprobar y rechazar todos
        los pagos entrantes. Un Usuario de Access Corrections Secure Mail
        puede enviar mensajes ("Correos electrónicos") a un Cliente de Access
        Corrections (es decir, la institución correccional que recibe los
        mensajes electrónicos en nombre del interno) en los Estados Unidos a
        través de Internet utilizando una tarjeta de crédito o débito Visa o
        MasterCard emitida en los Estados Unidos (conjuntamente, la "Tarjeta
        bancaria"). El personal de la agencia correccional tiene la facultad
        de revisar, aprobar y rechazar todos los mensajes entrantes. Cuando lo
        exija la ley aplicable, los pagos deberán ser informados a las
        autoridades federales, estatales o locales. Access Corrections le
        solicitará cierta información que nos permita, entre otras cosas,
        verificar su identidad y recibir la autorización correspondiente de la
        Tarjeta bancaria; y cualquier otra información que el Cliente requiera
        para enviar el Pago o el Correo. Consulte la Política de privacidad de
        Access Corrections para obtener más detalles relativos al uso de esta
        información por parte de Access Corrections.
</p>

<h2>Acceso de la agencia</h2>

<p>
   El Usuario está de acuerdo en que el personal de la agencia
        correccional tiene la facultad de revisar, aprobar y rechazar todos
        los pagos entrantes y los correos electrónicos entregados por Access
        Corrections. Si el personal de la agencia considera que un correo
        electrónico es inapropiado, rechazará la entrega al interno designado.
        No habrá reembolsos para los correos electrónicos considerados
        inapropiados por el personal de la agencia. Todos los usuarios de
        Access Corrections deben ser conscientes de que toda la información,
        lo que incluye, entre otros, el pago, los correos electrónicos, el
        nombre y la dirección, es accesible para el personal de la agencia
        para su revisión y aprobación. Todos los usuarios de Access
        Corrections reconocen que el personal de la agencia correccional tiene
        la aprobación para el uso de toda la información transmitida a través
        de Access Corrections para fines legales y de investigación. La
        información transmitida a través de Access Corrections puede ser
        utilizada y distribuida por personal que participa en el sector
        correccional, con fines de investigación (pública y privada) o de
        seguridad pública, específicamente, el Departamento de Seguridad
        Nacional y cualquier otra agencia antiterrorista (conjuntamente, el
        "Orden público").
</p>

<h2>USUARIOS DEL DEPARTAMENTO CORRECCIONAL DE OREGÓN</h2>

<p>
   El Departamento Correccional de Oregón restringe el contenido de los
        mensajes entrantes y salientes de los internos. Está prohibido el
        lenguaje sexualmente explícito, y conllevará que su mensaje sea
        rechazado. Todo material que pueda causar una preocupación sobre la
        seguridad o sobre el programa está prohibido y será rechazado. Se
        rechazarán las fotografías que muestren genitales humanos o que
        promocionen actividades criminales. Estas restricciones se basan en
        los criterios que se encuentran en las Reglas Administrativas de
        Oregón, División 291 a 131, Reglas sobre el correo (para internos).
        Puede encontrar las reglas sobre el correo en el sitio web del
        Departamento Correccional de Oregón.
</p>

<h2>USUARIOS DEL CONDADO DE POLK, FL</h2>

<p>
   Si el residente debe al centro algún pago de tarifas o multas, se
        deducirá de los depósitos realizados antes de ingresarse en la cuenta
        del residente. Llame al centro para obtener información sobre las
        deudas.
</p>

<h2>Tarifas</h2>

<p>
  Como contraprestación del uso del Servicio, usted acepta pagarle a
        Access Corrections una tarifa por cada Pago o por cada Correo
        electrónico que envíe de acuerdo con la tasa aplicable vigente en ese
        momento ("Tarifa del servicio"). La Tarifa del servicio
        correspondiente a su Pago le será proporcionada antes de que autorice
        de forma definitiva el Pago, además de cualquier otra tarifa aplicable
        por servicios adicionales. Ninguna Tarifa de servicio es reembolsable.
</p>

<h2>Pago</h2>

<p>
   La Tarifa del servicio y el monto del Pago deben abonarse antes de que
        Access Corrections procese el Pago o envíe el Correo electrónico.
        Usted debe pagar el Servicio con una Tarjeta bancaria. Si Access
        Corrections no recibe la autorización del emisor de la tarjeta, el
        Pago no será procesado, y los fondos no se transmitirán al Cliente, o
        los créditos de correo electrónico no serán recibidos. Cada vez que
        utilice el Servicio, usted acepta que Access Corrections está
        autorizada para cobrar de la cuenta de su Tarjeta bancaria designada
        el monto del Pago principal, la Tarifa del servicio y cualquier otra
        tarifa aplicable. (Su acuerdo con el emisor de la tarjeta rige el uso
        de esta, y debe consultar ese acuerdo para determinar sus derechos y
        obligaciones como titular de la tarjeta, lo que puede incluir una
        tarifa por "adelanto en efectivo").
</p>

<h2>Impugnaciones</h2>

<p>
   Este Acuerdo del usuario estará regido por y se interpretará de
        acuerdo con las leyes del estado de Misuri, Estados Unidos de América,
        sin consideración de ningún conflicto con principios legales.
        Cualquier acción para hacer cumplir este Acuerdo del usuario deberá
        ser interpuesta ante el tribunal federal del distrito este de Misuri o
        antes los tribunales estatales ubicados en el condado de San Luis,
        Misuri. Al utilizar el Servicio, usted se somete a la jurisdicción y
        al fuero de estos tribunales. Salvo que esté prohibido, usted acepta
        que todas las impugnaciones, los reclamos y las causas de acción que
        surjan directa o indirectamente del uso del Servicio se resolverán de
        manera individual, sin recurrir a ninguna forma de demanda colectiva.
        Cualquier reclamo o causa de acción que pueda tener con respecto al
        Acuerdo del usuario deberá ser iniciado dentro de un (1) año después
        de que haya surgido el reclamo o la causa de acción,
        independientemente de cualquier ley que disponga lo contrario.
</p>

<h2>Disposiciones generales</h2>

<p>
  Si alguna disposición de este Acuerdo del usuario se considera
        inválida o inejecutable, dicha disposición se interpretará en
        conformidad con la ley aplicable, y se exigirá el cumplimiento de las
        demás disposiciones. Los encabezados se incluyen con fines de
        referencia únicamente y de ninguna manera definen, limitan,
        interpretan o describen el alcance de la sección. Nuestra incapacidad
        para hacer cumplir alguna disposición de este Acuerdo del usuario no
        constituirá una renuncia a esa ni a ninguna otra disposición. Este
        Acuerdo del usuario y los documentos incorporados por referencia
        exponen el acuerdo completo entre usted y Access Corrections en
        relación con el uso que usted haga del Servicio.
</p>

<h2>RENUNCIA DE GARANTÍAS Y LIMITACIÓN DE RESPONSABILIDAD</h2>

<p>
   ACCESS CORRECTIONS PROVEE EL SITIO DE ACCESS CORRECTIONS Y LA INTERFAZ
        DE LAS CABINAS (CONJUNTAMENTE, LA "PLATAFORMA DE SERVICIOS") TAL COMO
        SON Y COMO ESTÁN DISPONIBLES. ACCESS CORRECTIONS NIEGA TODA GARANTÍA,
        EXPRESA O IMPLÍCITA, EN CUANTO AL FUNCIONAMIENTO DE LA PLATAFORMA DE
        SERVICIOS O EN CUANTO A LA INFORMACIÓN, EL CONTENIDO, LOS MATERIALES,
        LOS PRODUCTOS O LOS SERVICIOS INCLUIDOS EN EL SITIO O EN LA INTERFAZ
        DE LAS CABINAS. USTED ACEPTA EXPRESAMENTE QUE SU USO DE LA PLATAFORMA
        DE SERVICIOS ES POR SU CUENTA Y RIESGO, Y QUE ES EXCLUSIVAMENTE
        RESPONSABLE POR LA EXACTITUD DE LA INFORMACIÓN PERSONAL Y DE PAGO QUE
        PROPORCIONE. EN LA MAYOR MEDIDA PERMITIDA CONFORME A LA LEY APLICABLE,
        ACCESS CORRECTIONS RECHAZA TODAS LAS GARANTÍAS, EXPRESAS O IMPLÍCITAS,
        INCLUIDAS, ENTRE OTRAS, LAS GARANTÍAS DE COMERCIALIZACIÓN Y DE APTITUD
        PARA UN PROPÓSITO PARTICULAR. ACCESS CORRECTIONS NO GARANTIZA QUE EL
        SITIO O LA INTERFAZ DE LAS CABINAS, SUS SERVICIOS, O LOS CORREOS
        ELECTRÓNICOS ENVIADOS DESDE ACCESS CORRECTIONS SE ENCUENTREN LIBRES DE
        VIRUS O DE OTROS COMPONENTES DAÑINOS.
</p>

<p>
   ACCESS CORRECTIONS (ASÍ COMO SUS FUNCIONARIOS, DIRECTORES, EMPLEADOS,
        AFILIADOS Y ACCIONISTAS) NO SERÁ RESPONSABLE POR DAÑOS DE NINGÚN TIPO
        DERIVADOS DE LA UTILIZACIÓN DE ESTE SITIO, DE LA NO AUTORIZACIÓN DEL
        PAGO CON UNA TARJETA BANCARIA DEL USUARIO POR PARTE DE LA COMPAÑÍA DE
        LA TARJETA DE CRÉDITO, POR INTERRUPCIONES EN LA PLATAFORMA DE
        SERVICIOS O POR ERRORES, DEMORAS O ENVÍOS INCORRECTOS DE UN PAGO,
        INDEPENDIENTEMENTE DE LA CAUSA, LO QUE INCLUYE, ENTRE OTROS, DAÑOS
        DIRECTOS, INDIRECTOS, FORTUITOS, PUNITIVOS Y CONSECUENTES.
</p>

<p>
  CIERTAS LEYES ESTATALES NO PERMITEN LIMITACIONES SOBRE LAS GARANTÍAS
        IMPLÍCITAS O LA EXCLUSIÓN O LIMITACIÓN DE CIERTOS DAÑOS. SI ESTAS
        LEYES SON APLICABLES A SU CASO, ALGUNAS O TODAS LAS RENUNCIAS,
        EXCLUSIONES O LIMITACIONES ANTERIORMENTE MENCIONADAS PUEDEN NO SER
        APLICABLES A SU CASO, E INCLUSO PODRÍA TENER DERECHOS ADICIONALES.
</p>

<h2> ¡Ayude a prevenir el fraude al consumidor!</h2>

<h3 className="a11y">
  ¿Está enviando dinero a alguien que no conoce o cuya identidad no
        puede verificar?
</h3>

<h3 className="a11y">
  ¿Está respondiendo a una oferta por Internet o por teléfono que no
        está seguro de que sea honesta?
</h3>

<h3 className="a11y">
   ¿Está enviando dinero porque le "garantizaron" una tarjeta de crédito
        o un préstamo?
</h3>

<p>
  <strong>
    Si es así, llame al 1-866-345-1884 y solicite a un representante del
          centro de llamadas de Access Corrections que detenga su
          transferencia de inmediato.
  </strong>
</p>`,
  affirmativeButton: { color: "primary", caption: "Close" },
};

export const AnchorClickTermsAndConditionsDialogEnglish: DialogChildren = {
  open: true,
  title: "TERMS & CONDITIONS",
  subtitle: "",
  replaceId: "replaceId",
  content: `
  
  <div>
    <h2>ACCESS CORRECTIONS</h2>
    <h2>TERMS & CONDITIONS</h2>
    <div id="replaceId"> 
      <h2>Last Updated: January 1, 2024</h2>
    </div>
    <hr/>
    <h3>Introduction</h3>
    <p> 
      As a condition to using Keefe Commissary Network, L.L.C. dba Access
      Corrections’ (“Access Corrections”) payment services and this
      website, you agree to these Terms and Conditions. Access Corrections
      provides its services and this website subject to these Terms and
      Conditions and all applicable laws and regulations. By accessing
      and/or using this website (“Site”), you fully and unconditionally
      accept and agree to be bound by these Terms and Conditions. Access
      Corrections reserves the right at its discretion to change these
      Terms and Conditions with or without notice. Your continued use
      following the posting of any changes to these Terms and Conditions
      constitutes your acceptance of those changes. "You," "User," or
      "Customer" means any person or entity using the Site and Access
      Corrections Service (as defined below).
    </p>
    <div>
      <h3>The Access Corrections Service</h3>
      <p>
        A User may send money to an inmate’s trust account (or to any
        sub-accounts under the trust account) at an Access
        Corrections-affiliated correctional institution or make a payment to
        a government agency partnering with Access Corrections (a “Client”)
        (hereinafter referred to as a “Payment”). Access Corrections and its
        partners, including Clients, have the authority to review, approve,
        delay, withhold and/or reject a Payment. Access Corrections offers
        Users of the Service an opportunity to make Payments through the
        following channels, however, Payment options are subject to Client
        approval so they will vary: (1) over the Internet or telephone using
        a Visa or MasterCard branded credit card or debit card (collectively
        "Bank Card"), (2) at a partner location using cash (i.e., Western
        Union), (3) at an Access Corrections kiosk located at a Client using
        cash or a Bank Card, or (4) by sending a personal check or money
        order to an Access Corrections’ lockbox (collectively, the "Access
        Corrections Service").
        </p>
    </div>

    <div>
      <h3>Payment Information</h3>
      <p>
        To facilitate Payments, you will be required to provide Access
        Corrections with certain information to allow us, among other
        things: to verify your identity; to receive appropriate Bank Card
        authorization, if applicable; to comply with applicable laws and our
        internal controls, policies and procedures; and to gather any other
        information a Client requires of you to send the Payment. Please
        refer to Access Corrections' Privacy Policy regarding Access
        Corrections' use of this information. When required by applicable
        law, Payments will be reported to federal, state or local
        authorities.
      </p>
    </div>

    <div>
      <h3>Identity Authentication</h3>
      <p> You authorize Access Corrections, directly or through third parties,
        to make any inquiries we consider necessary to validate your
        identity. This may include asking you for further information,
        requiring you to provide your date of birth, and/or other
        information that will allow us to reasonably identify you. We may
        also require you to take steps to confirm ownership of your email
        address and/or phone number, or verify your information against third
        party databases or through other sources. We may also ask to see
        your driver's license or other identifying documents. Access
        Corrections reserves the right to close, suspend, limit or deny
        access to your account and/or the Access Corrections Service in the
        event we are unable to obtain or verify this information.
      </p>
    </div>

    <div>
      <h3>Fees</h3>
      <p>
        You agree to pay Access Corrections a fee for using the Access
        Corrections Service at the rate in effect at the time you make a
        Payment (the "Service Fee"). Access Corrections is not responsible
        for any deductions made by the correctional institution (for reasons
        such as restitution, child support, etc.) prior to the crediting of
        your Payment to the inmate.
      </p>
    </div>

    <div>
      <h3>Refunds</h3>
      <p>
        Unless otherwise permitted by applicable law, you may not cancel or
        obtain a refund for a Payment and/or Service Fee once the Payment
        has been credited to the recipient you designate. Fraudulent
        transactions may result in the loss of your money with no recourse.
      </p>
    </div>

    <div>
      <h3>Funds Availability</h3>
      <p>
        Access Corrections generally transmits Payments within one (1) to
        two (2) business days, with the exception of lockbox money order and
        personal check Payments. While Access Corrections attempts to
        process Payments within these time frames, the Client may take
        additional time in posting those Payments,
        and Access Corrections has no control over, and is not responsible
        for any delay caused by, the Client’s processes and procedures.
      </p>
    </div>

    <div>
      <h3>Money Orders</h3>
      <p> All money orders must be made payable to "Access Corrections". A
        deposit slip and any accompanying information required by the Client
        must be filled out and submitted with every money order. All deposit
        slips must be legible and completely filled out. Any materials sent
        with the money order other than the deposit slip will be discarded.
        Access Corrections is not responsible for money orders lost in the
        mail or otherwise lost in transit, or for money orders that are sent
        to the provided address which did not reach the intended recipient.
        If Access Corrections receives a money order and there is a problem
        with the deposit, Access Corrections will mail the money order and
        deposit slip back to the Customer’s address provided on the deposit
        slip.
      </p>
    </div>

    <div>
      <h3>Payment</h3>
      <p>
      You are required to pay the Service Fees (along with the principal 
        Payment amount) before Access Corrections processes the Payment. 
        By making a Payment with a Bank Card, you authorize Access 
        Corrections to process the Payment. When using a Bank Card, if 
        Access Corrections does not receive authorization from the card 
        issuer, the Payment will not be processed and a hold may be placed 
        on your Bank Card which can only be removed by the issuing bank. 
        Each time you use the Access Corrections Service, you agree that 
        Access Corrections is authorized to charge your designated Bank 
        Card account for the principal Payment amount, the Service Fee 
        and any other applicable fees including, but not limited to, fees 
        charged or assessed by the Bank Card issuer (your agreement with 
        your card issuer governs use of your card, and you must refer to 
        that agreement to ascertain your rights and liabilities as a 
        cardholder, which may include a “cash advance” fee). In the event 
        that your transaction is reported as unauthorized and results in 
        a chargeback, the inmate who received the chargedback funds will 
        be restricted from receiving future transactions until Access 
        Corrections is reimbursed or the issue is otherwise resolved. In 
        addition to the Payment amount, reimbursement will include a $25 
        chargeback fee to cover costs incurred by Access Corrections for 
        the presentment of a chargeback and recovery of the disputed Payment. 
        By making a Payment to a recipient who is restricted from receiving 
        funds, you agree that your Payment will first be applied to reimbursing 
        Access Corrections for all chargeback transactions received by the recipient 
        along with any chargeback transaction fee(s). Once reimbursed for the 
        chargeback transaction received by the recipient and the $25 chargeback fee, 
        Access Corrections will apply your Payment to the recipient in accordance with 
        these Terms and Conditions.
        <p>
        You understand if you have an unpaid balance to Access Corrections
        and do not make satisfactory payment arrangements, your account may
        be placed with an external collection agency. You will be
        responsible for reimbursement of any fees from the collection
        agency, including all costs and expenses incurred collecting your
        account, and possibly including reasonable attorney’s fees if so
        incurred during collection efforts.
        </p>
        <p>
        In order for Access Corrections or its designated external
        collection agency to service your account, and where not prohibited
        by applicable law, you agree that Access Corrections and the
        designated external collection agency are authorized to (i) contact
        you by telephone at the telephone number(s) you are providing,
        including wireless telephone numbers, which could result in charges
        to you, (ii) contact you by sending text messages (message and data
        rates may apply) or emails, using any email address you provide and
        (iii) methods of contact may include using pre-recorded/artificial
        voice message and/or use of an automatic dialing device, as
        applicable.
        </p>
      </p>
    </div>

    <div>
      <h3>Other Charges</h3>
      <p>Access Corrections is not responsible for any fees or charges that
        may be imposed by the financial institution associated with your
        Payment. For example, some credit card issuers may treat the use of
        your credit card to purchase the Service as a "cash advance" rather
        than a purchase transaction, and may impose additional fees and
        interest rates for the transaction. Access Corrections is not
        responsible for any non-sufficient funds charges, chargeback fees or
        other similar charges that might be imposed on you by your bank,
        credit card issuer or other provider.
        </p>
    </div>

    <div>
      <h3>Use of the Site</h3>
      <p>Access Corrections maintains the Site for your non-commercial
        personal use. Your use of the Site for any other purpose is
        permissible only upon the express prior written consent of Access
        Corrections. Without limiting the foregoing, you may not: (1) use
        the Site in a commercial manner, including by distributing,
        transmitting or publishing the Site or any of its content; (2)
        interfere with others’ use of the Site; (3) impair the Site’s
        operation or interfere with or disrupt the servers or networks
        connected to it; (4) interfere with Access Corrections’ intellectual
        property rights; (5) frame or otherwise co-brand the Site or any of
        its content; (6) deep-link to any portion of the Site; (7) provide
        false, inaccurate or misleading information; or (8) use the Site for
        any illegal purpose. We reserve the right in our sole discretion to
        terminate or restrict your use of the Site, without notice, for any
        or no reason, and without liability to you or any third party. In
        such event, we may inform your Internet service provider of your
        activities and take appropriate legal action.
        </p>
    </div>

    <div>
      <h3>Site Modifications</h3>
      <p>We reserve the right, in our sole discretion, to modify, suspend or
        discontinue any part of the Site at any time, without notice or
        liability to you or any third party. We also reserve the right, in
        our sole discretion, to impose limits on certain features and
        services.
        </p>
    </div>

    <div>
      <h3>Privacy Policy</h3>
      <p>Access Corrections takes your privacy seriously. Please review our
        Privacy Policy, the terms of which are incorporated into these Terms
        and Conditions.
        </p>
    </div>

    <div>
      <h3>Links To Other Sites</h3>
      <p>The Site may include links to third-party Websites. Access
        Corrections does not control and is not responsible for the content
        or privacy policies of any linked site, and the inclusion of any
        link on the Site does not imply our endorsement of it.
        </p>
    </div>

    <div>
      <h3>Electronic Communications</h3>
      <p>By using the Site or sending us an e-mail, you consent to receiving
        electronic communications and notices from Access Corrections. You
        agree that all agreements, notices, disclosures and other
        communications that we provide to you electronically satisfy any
        legal requirement that such communications be in writing.
        </p>
    </div>

    <div>
      <h3>Intellectual Property</h3>
       <p>
        <u>Copyright</u>. 
        All copyrightable text, graphics, logos, sound,
        downloads, software, button icons, other material and the overall
        design of the Site (collectively, the “Content”) included in or made
        available through the Site, is copyrighted by Access Corrections or
        our content suppliers and is protected by United States or
        international copyright laws. All rights reserved. You may print a
        copy of the Content on your computer only for your own personal,
        non-commercial home use, provided that you do not remove any
        copyright, trademark or other proprietary notices from the Content.
        Any other use of the Content is strictly prohibited, unless you have
        prior written permission.
        </p>
        <u>
          Notice and Procedure for Making Claims of Copyright Infringement.
        </u>
        Access Corrections respects the intellectual property of others.
        If you believe that your work has been copied in a way that
        constitutes copyright infringement, please contact Access
        Corrections’ Legal Department at TKC Holdings, Inc., Intellectual
        Property Questions, 1260 Andes Boulevard, St. Louis, Missouri,
        63132. Please include: (1) a physical signature of the person
        authorized to act on behalf of the owner of the copyright or other
        proprietary interest; (2) a description of the copyrighted work or
        other protected material that you claim has been infringed upon; (3)
        a description of where the material is located on the Site; (4) your
        address, telephone number, and e-mail address; (5) your statement
        that you have a good faith belief that the disputed use is not
        authorized by the copyright or other interest owner, its agent or
        the law; and (6) your statement, made under penalty of perjury, that
        the information in your notice is accurate and that you are the
        copyright or other interest owner or are authorized to act on the
        owner’s behalf.
        <p>    
        <u>Trademarks</u>. 
        ACCESS CORRECTIONS, ACCESS SECURE DEPOSIT, and
        ACCESS SECURE MAIL are included in the family of trademarks and
        service marks owned by Access Corrections in the United States and
        other countries (this is not an all-inclusive list of Access
        Corrections’ trademarks and service marks). Access Corrections’
        trademarks and service marks may not be used in connection with any
        product or service that is not Access Corrections’ in any manner
        that is likely to cause confusion among customers, in any manner
        that disparages or discredits Access Corrections, or without our
        prior written permission. All other trademarks not owned by Access
        Corrections that appear on the Site are the property of their
        respective owners, who may or may not be affiliated with, connected
        to, or sponsored by Access Corrections.
        </p>
    </div>

    <div>
      <h3>Your Account</h3>
      <p>If you use the Site, you are responsible for maintaining the
        confidentiality of your account and password and for restricting
        access to your computer, and you agree to accept responsibility for
        all activities that occur under your account or password. You must
        be at least eighteen (18) year of age and able to form a binding
        contract under applicable law to use the services. Access
        Corrections reserves the right to refuse service, terminate
        accounts, remove or edit content, or cancel orders in its sole
        discretion. If your account remains dormant (i.e. no logins or
        payments are made from your account) for an extended period of time,
        Access Corrections reserves the right to deactivate your account. In
        the event your account is dormant and is deemed “unclaimed” or
        “abandoned” under your state’s law, Access Corrections will provide
        you with notice as required by applicable law. Please note that if
        your account is deactivated for any reason, you will be required to
        open a new account prior to using the Access Corrections Service.
        </p>
    </div>

    <div>
      <h3>Use of Information Submitted</h3>
        <p>
        To help the government fight the funding of terrorism and money
        laundering activities, Federal law requires us to obtain, verify and
        record information that identifies each person who engages in
        financial services with Keefe Commissary Network, L.L.C. We will ask
        for your name, address and other information that will allow us to
        identify you in conducting this transaction. Failure to provide all
        requested information may result in your Payment being delayed or
        rejected.
        </p>
        <p>
        You agree that Access Corrections is free to use any comments,
        information or ideas contained in any communication you may send to
        us without compensation, acknowledgment or payment to you, for any
        purpose whatsoever, including, but not limited to, developing,
        manufacturing and marketing products and services, or modifying or
        improving the Site or other products or services.
        </p>
        <p>
        Access Corrections reserves the right to verify the billing
        information provided subsequent to your authorization of the
        transaction and prior to the funds reaching the recipient. 
        As part of this process you may be contacted by our staff.
        </p>
        <p>
        Please be aware that if you are selected for our verification
        process and you do not respond to the phone requests made by our
        personnel your transaction may be canceled at our discretion. In the
        event of a cancellation your credit card will receive a full refund
        for the amount you attempted to send through Access Corrections.
        </p>
    </div>

    <div>
      <h3>
        Disclaimer of Warranties and Limitation of Liability
      </h3>
      <p>THIS SITE AND THE ACCESS CORRECTIONS SERVICE ARE PROVIDED BY ACCESS
        CORRECTIONS ON AN "AS IS" AND "AS AVAILABLE" BASIS. ACCESS
        CORRECTIONS MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND,
        EXPRESS OR IMPLIED, AS TO THE OPERATION OF THIS SITE, THE
        INFORMATION, CONTENT, MATERIALS, PRODUCTS OR SERVICES INCLUDED ON
        THIS SITE OR THE ACCESS CORRECTIONS SERVICE. YOU EXPRESSLY AGREE
        THAT YOUR USE OF THIS SITE AND THE ACCESS CORRECTIONS SERVICE IS AT
        YOUR SOLE RISK AND THAT YOU ARE SOLELY RESPONSIBLE FOR THE ACCURACY
        OF THE PERSONAL AND PAYMENT INFORMATION THAT YOU PROVIDE. TO THE
        FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, ACCESS CORRECTIONS
        DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT
        LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE. ACCESS CORRECTIONS DOES NOT WARRANT THAT THIS
        SITE, THE ACCESS CORRECTIONS SERVICE OR E-MAIL SENT FROM ACCESS
        CORRECTIONS ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
        </p>
        <p> 
        ACCESS CORRECTIONS (AS WELL AS ITS OFFICERS, DIRECTORS, EMPLOYEES,
        AFFILIATES AND STOCKHOLDERS) WILL NOT BE LIABLE FOR ANY DAMAGES OF
        ANY KIND ARISING FROM THE USE OF THIS SITE, ANY CREDIT CARD
        COMPANY'S NON-AUTHORIZATION OF A USER'S BANK CARD PAYMENT, FOR
        DISRUPTIONS IN SERVICE ON THIS SITE, OR FOR ERROR, DELAY OR
        MIS-DELIVERY OF A PAYMENT, REGARDLESS OF THE CAUSE, INCLUDING
        (WITHOUT LIMITATION) DIRECT, INDIRECT, INCIDENTAL, PUNITIVE AND
        CONSEQUENTIAL DAMAGES. CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS
        ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN
        DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
        DISCLAIMERS, EXCLUSIONS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU
        MIGHT HAVE ADDITIONAL RIGHTS.
        </p>
    </div>

    <div>
      <h3>Indemnity</h3>
      <p> You agree to indemnify and hold Access Corrections and its related
        companies and each of their respective directors, officers,
        employees and agents harmless from and against any third-party claim
        or cause of action, including reasonable attorneys’ fees and costs,
        arising, directly or indirectly, in whole or in part, out of your
        access or use of the Site, your breach of these Terms and
        Conditions, your use of the Access Corrections Service, and your
        violation of any law or the rights of any person.
      </p>
    </div>

    <div>
      <h3>Disputes</h3>
      <p>These Terms and Conditions shall be governed by and construed in
        accordance with the laws of the State of Missouri, United States of
        America, without regard to its conflict of law principles. Any
        action to enforce these Terms and Conditions shall be brought in the
        federal court in the Eastern District of Missouri or the state
        courts located in St. Louis County, Missouri. By using the Site, you
        consent to the jurisdiction and venue of these courts. Except where
        prohibited, you agree that any and all disputes, claims and causes
        of action directly or indirectly arising out of the Site shall be
        resolved individually, without resort to any form of class action.
        Any claim or cause of action you may have with respect to the Site
        or the Access Corrections Service must be commenced within one (1)
        year after the claim or cause of action arises, regardless of any
        law to the contrary.
        </p>
    </div>

	<div>
      <h3>General</h3>
      <p> If any provision of these Terms and Conditions is held to be invalid
        or unenforceable, that provision shall be construed consistent with
        applicable law, and the remaining provisions shall be enforced.
        Headings are for reference purposes only and in no way define,
        limit, construe or describe the scope of such section. Our failure
        to enforce any provision of these Terms and Conditions shall not
        constitute a waiver of that or any other provision. These Terms and
        Conditions, incorporated herein by this reference, set forth the
        entire agreement between you and Access Corrections in connection
        with your use of the Site and Access Correction Service.
        </p>
    </div>

	<div>
		<h3>Fraudulent or Disputed Activity</h3>
		<p> 
		 You agree that we may decline or prevent transactions to or from your
          account to protect you or us, or to comply with legal or regulatory
          requirements. These actions include, but are not limited to, delaying
          any specific transfer of funds to your account or withdrawal, payment
          or transfer of funds from your account pending further investigation,
          limiting the ability of the depositor to deposit further funds,
          restricting the recipient from receiving future transactions, freezing
          your account, and debiting funds from your account (up to the total
          amount of all funds in our account) in any of the following
          circumstances:
		</p>
		 <ol type="a">
          <li>
            We suspect that you may be the victim of a fraud, scam or financial
            exploitation, even though you have authorized the transaction(s);
          </li>
          <li>
            We suspect that any transaction may involve illegal activity or may be fraudulent;
          </li>
          <li>
            We are complying in our sole judgment, with any federal, state or
            local law, rule or regulation, including federal asset control and
            sanction rules and anti-money-laundering rules, or with our policies
            adopted to assure that we comply with those laws, rules or
            regulations;
          </li>
          <li>A disputed transaction results in a chargeback; or</li>
          <li>
            We reasonably believe that doing so is necessary to avoid a loss or
            reduce risk to us.
          </li>
        </ol>
		<p> We also reserve the right to debit your account to recover our costs
          incurred by us for the fraudulent or disputed transaction. If your
          account has been restricted from receiving funds as provided above,
          you agree that any payment or transfer of funds to your account will
          first be applied to reimbursing us for all fraudulent or disputed
          transactions received by the recipient along with any related fee(s)
          and costs incurred by us for such transactions.
		</p>
		<p>Subject to applicable law, we will have no liability for any action we
          take under this section.
		</p>
	</div>

    <div>
      <h3>Contact Us</h3>
      <p>If you have any questions regarding these Terms and Conditions,
        please contact us at
        <a class="ot-btn-anchor" href="mailto:customerservice@accesscorrections.com">
          customerservice@accesscorrections.com.
        </a>
        </p>
    </div>
  </div>
`,
  affirmativeButton: { color: "primary", caption: "Close" },
};

export const AnchorClickTermsAndConditionsDialogSpanish: DialogChildren = {
  open: true,
  title: "TÉRMINOS Y CONDICIONES",
  subtitle: "",
  replaceId: "replaceId",
  content: `
  <div>
    <h2>ACCESS CORRECTIONS</h2>
    <h2>TÉRMINOS Y CONDICIONES</h2>
    <div id="replaceId"> 
      <h2>Última actualización: 1.o de enero de 2024</h2>
    </div>
    <hr/>
    <h3>Introducción</h3>
    <p> 
      Como condición para utilizar los servicios de pago de Keefe Commissary
          Network, LLC, nombre comercial Access Corrections ("Access
          Corrections"), y este sitio web, usted acepta estos Términos y
          condiciones. Access Corrections proporciona sus servicios y este sitio
          web conforme a estos Términos y condiciones, y a todas las leyes y
          regulaciones aplicables. Al acceder o al usar este sitio web
          (“Sitio”), usted acepta total e incondicionalmente estos Términos y
          condiciones y se compromete a cumplirlos. Access Corrections se
          reserva el derecho a cambiar a su discreción estos Términos y
          condiciones con o sin previo aviso. El uso continuado tras la
          publicación de cualquier cambio a estos Términos y condiciones
          constituye la aceptación de dichos cambios. "Usted", "Usuario" o
          "Cliente" hacen referencia a cualquier persona o entidad que utilice
          el Sitio y el Servicio de Access Corrections (como se define a
          continuación).
    </p>
    <div>
      <h3>El servicio de Access Corrections</h3>
      <p>
        Un Usuario puede enviar dinero a la cuenta fiduciaria de un recluso (o
          a cualquier subcuenta bajo la cuenta fiduciaria) en una institución
          correccional afiliada a Access Corrections o realizar un pago a una
          agencia gubernamental que esté asociada con Access Corrections (un
          "Cliente") (en adelante denominado “Pago”). Access Corrections y sus
          socios, incluidos los Clientes, tienen la facultad de revisar,
          aprobar, retrasar, retener o rechazar un Pago. Access Corrections
          ofrece a los Usuarios del servicio la oportunidad de realizar Pagos a
          través de los siguientes canales; sin embargo, las opciones de Pago
          están sujetas a la aprobación del Cliente, por lo que variarán: (1) a
          través de Internet o por teléfono con una tarjeta de crédito o débito
          (en conjunto, "Tarjeta bancaria") Visa o MasterCard; (2) en un local
          asociado con efectivo (p. ej., Western Union); (3) en una cabina de
          Access Corrections ubicada en un Cliente utilizando efectivo o una
          Tarjeta bancaria; o (4) enviando un cheque personal o giro postal a la
          caja de seguridad de Access Corrections (en conjunto, el "Servicio de
          Access Corrections").
        </p>
    </div>

    <div>
      <h3>Información de pago</h3>
      <p>
        Para facilitar los Pagos, se le solicitará que proporcione cierta
          información a Access Corrections que nos permita, entre otras cosas:
          verificar su identidad; recibir la autorización correspondiente de la
          Tarjeta bancaria, si corresponde; cumplir con las leyes aplicables y
          nuestros controles, políticas y procedimientos internos; y recopilar
          cualquier otra información que el Cliente requiera de usted para
          enviar el Pago. Consulte la Política de privacidad de Access
          Corrections para obtener información sobre cómo Access Corrections usa
          esta información. Cuando lo exija la ley aplicable, los pagos deberán
          ser informados a las autoridades federales, estatales o locales.
      </p>
    </div>

    <div>
      <h3>Autenticación de identidad</h3>
      <p> Usted autoriza a Access Corrections, directamente o a través de
          terceros, para que realice cualquier consulta que consideremos
          necesaria para validar su identidad. Esto puede incluir solicitarle
          más información, exigirle que proporcione su fecha de nacimiento u
          otra información que nos permita identificarlo de manera razonable.
          También es posible que le solicitemos que tome medidas para confirmar
          la propiedad de su dirección de correo electrónico o número de
          teléfono, o que verifiquemos su información con bases de datos de
          terceros o mediante otras fuentes. También podemos solicitar ver su
          licencia de conducir u otros documentos de identificación. Access
          Corrections se reserva el derecho de cerrar, suspender, limitar o
          denegar el acceso a su cuenta o al Servicio de Access Corrections en
          caso de que no podamos obtener o verificar esta información.
      </p>
    </div>

    <div>
      <h3>Tarifas</h3>
      <p>
        Usted acepta pagar una tarifa a Access Corrections por utilizar el
          Servicio de Access Corrections a la tarifa vigente en el momento de
          realizar un Pago (la "Tarifa del servicio"). Access Corrections no es
          responsable de las deducciones que realice la institución correccional
          (por razones tales como restitución, manutención infantil, etc.) antes
          de la acreditación de su Pago al recluso.
      </p>
    </div>

    <div>
      <h3>Reembolsos</h3>
      <p>
          A menos que la ley aplicable permita lo contrario, no podrá cancelar
          ni obtener el reembolso de un Pago o Tarifa de servicio una vez que el
          Pago se haya acreditado al destinatario que designe. Las transacciones
          fraudulentas pueden conllevar a la pérdida de su dinero sin recursos.
      </p>
    </div>

    <div>
      <h3>Disponibilidad de fondos</h3>
      <p>
        Access Corrections generalmente transmite los Pagos en un plazo de uno
          (1) a dos (2) días hábiles, a excepción de los giros postales a cajas
          de seguridad y los Pagos con cheques personales. Si bien Access
          Corrections intenta procesar los Pagos dentro de estos plazos, el
          Cliente podría tomarse más tiempo para acreditar esos Pagos, y Access
          Corrections no tiene control ni es responsable de los retrasos
          causados por los procesos y procedimientos del Cliente.
      </p>
    </div>

    <div>
      <h3>Giros postales</h3>
      <p>   Todos los giros postales se deben hacer pagaderos a "Access
          Corrections". Con cada giro postal, se debe completar y enviar un
          comprobante de depósito y toda la información complementaria que
          requiera el Cliente. Todos los comprobantes de depósito deben ser
          legibles y estar completos. Se descartará cualquier material que se
          envíe con el giro postal que no sea el comprobante de depósito. Access
          Corrections no es responsable de los giros postales perdidos en el
          correo, o de otro modo en tránsito, ni de los giros postales que se
          envían a la dirección proporcionada y no llegan al destinatario
          deseado. Si Access Corrections recibe un giro postal y hay un problema
          con el depósito, Access Corrections enviará el giro postal y el
          comprobante de depósito a la dirección del Cliente que figura en el
          comprobante de depósito.
      </p>
    </div>

    <div>
      <h3>Pago</h3>
      <p>
      Usted debe pagar las Tarifas del servicio (junto con el monto del Pago principal) antes de que Access Corrections procese el Pago. Cuando realiza un Pago con una Tarjeta bancaria, usted autoriza a Access Corrections a procesar el Pago. Al utilizar una Tarjeta bancaria, si Access Corrections no recibe la autorización del emisor de la tarjeta, el Pago no se procesará y se podrá colocar una retención en su Tarjeta bancaria, que solamente podrá eliminar el banco emisor. Cada vez que utilice el Servicio de Access Corrections, usted acepta que Access Corrections está autorizada para cobrar de la cuenta de su Tarjeta bancaria designada el monto del Pago principal, la Tarifa del servicio y cualquier otra tarifa aplicable, incluidas, entre otras, las tarifas cobradas o evaluadas por el emisor de la Tarjeta bancaria (su acuerdo con el emisor de la tarjeta rige el uso de esta, y debe consultar dicho acuerdo para determinar sus derechos y obligaciones como titular de la tarjeta, lo que puede incluir una tarifa por "adelanto en efectivo"). En el caso de que su transacción se informe como no autorizada y resulte en una devolución, el recluso que recibió dichos fondos no podrá recibir transacciones futuras hasta que se realice el reembolso a Access Corrections o se resuelva el problema. Además del monto del Pago, el reembolso incluirá una tarifa de devolución de $25 para cubrir los costos en los que haya incurrido Access Corrections para la presentación de una devolución y la recuperación del Pago en disputa. Al realizar un Pago a un destinatario que tiene restricciones para recibir fondos, usted acepta que su Pago se aplicará primero al reembolso de Access Corrections por todas las transacciones de devolución recibidas por el destinatario junto con cualquier tarifa por transacción de devolución. Una vez reembolsada la transacción de devolución recibida por el destinatario y la tarifa de devolución de $25, Access Corrections aplicará su pago al destinatario de acuerdo con estos Términos y condiciones.
      <p>
        Usted comprende que si tiene un saldo pendiente con Access Corrections
          y no hace arreglos de pago satisfactorios, su cuenta puede ser
          remitida a una agencia de cobro externa. Usted será responsable del
          reembolso de cualquier tarifa de la agencia de cobro, incluidos todos
          los costos y gastos incurridos en el cobro de la cuenta y,
          posiblemente, los honorarios razonables de abogados si se incurrió en
          ellos durante la gestión de cobro.
        </p>
        <p>
        Para que Access Corrections o la agencia de cobro externa designada
          administren su cuenta, y siempre que no lo prohíba la ley aplicable,
          usted acepta que Access Corrections y la agencia de cobro externa
          designada están autorizados a (i) ponerse en contacto con usted por
          teléfono a los números de teléfono que haya proporcionando, incluidos
          los números de teléfono inalámbricos, lo que podría generar cargos
          para usted, (ii) ponerse en contacto con usted mediante el envío de
          mensajes de texto (se pueden aplicar tarifas de mensajes y datos) o
          correos electrónicos, utilizando cualquier dirección de correo
          electrónico que proporcione y (iii) los métodos de contacto pueden
          incluir el uso de mensajes de voz pregrabados/artificiales o el uso de
          un dispositivo de marcación automática, según corresponda.
        </p>
      </p>
    </div>

    <div>
      <h3>Otros cargos</h3>
      <p>  Access Corrections no es responsable de ninguna tarifa o cargo que
          puedan ser impuestos por la institución financiera asociada con su
          Pago. Por ejemplo, algunos emisores de tarjetas de crédito pueden
          tratar el uso de su tarjeta de crédito para comprar el Servicio como
          un "adelanto de efectivo", en lugar de como una transacción de compra,
          y pueden imponer tarifas adicionales y tasas de interés por la
          transacción. Access Corrections no es responsable de ningún cargo por
          fondos insuficientes, cargos por devolución u otros cargos similares
          que su banco, emisor de tarjeta de crédito u otro proveedor puedan
          imponerle.
        </p>
    </div>

    <div>
      <h3>Uso del Sitio</h3>
      <p>Access Corrections mantiene el Sitio para su uso personal no
          comercial. El uso del Sitio para cualquier otro propósito se permite
          solo con el consentimiento previo y expreso por escrito de Access
          Corrections. Sin perjuicio de lo dispuesto anteriormente, usted no
          puede: (1) usar el Sitio de una manera comercial, lo que incluye
          distribuir, transmitir o publicar el Sitio o cualquiera de sus
          contenidos; (2) interferir con el uso del Sitio por parte de otros;
          (3) impedir el funcionamiento del Sitio o interferir o interrumpir los
          servidores o las redes conectadas a él; (4) interferir con los
          derechos de propiedad intelectual de Access Corrections; (5)
          involucrar o compartir la marca del Sitio o cualquiera de sus
          contenidos; (6) vincular a cualquier parte del Sitio; (7) proporcionar
          información falsa, inexacta o engañosa; o (8) usar el Sitio para
          cualquier propósito ilegal. Nos reservamos el derecho a terminar o
          restringir el uso del Sitio a nuestra entera discreción, sin previo
          aviso, por cualquier razón o sin ella, y sin ninguna responsabilidad
          hacia usted o cualquier tercero. En caso de que esto ocurra, podríamos
          informarle a su proveedor de servicios de Internet sobre sus
          actividades y tomar las medidas legales necesarias.
        </p>
    </div>

    <div>
      <h3>Modificaciones del Sitio</h3>
      <p>  Nos reservamos el derecho de modificar, suspender o interrumpir
          cualquier parte del Sitio a nuestra entera discreción, en cualquier
          momento, sin previo aviso ni responsabilidad ante usted o cualquier
          tercero. También nos reservamos el derecho de imponerles límites a
          ciertas características y servicios a nuestra entera discreción.
        </p>
    </div>

    <div>
      <h3>Política de privacidad</h3>
      <p> Access Corrections toma en serio su privacidad. Revise nuestra
          Política de privacidad. Los términos de dicha política se incorporan a
          estos Términos y condiciones.
        </p>
    </div>

    <div>
      <h3>Enlaces a otros sitios</h3>
      <p> El Sitio puede incluir enlaces a sitios web de terceros. Access
          Corrections no controla y no es responsable por el contenido o las
          políticas de privacidad de cualquier sitio enlazado, y la inclusión de
          cualquier enlace en el Sitio no implica nuestra adhesión.
        </p>
    </div>

    <div>
      <h3>Comunicaciones electrónicas</h3>
      <p>  Al usar el Sitio o enviarnos un correo electrónico, usted acepta
          recibir comunicaciones electrónicas y avisos de Access Corrections.
          Usted acepta que todos los acuerdos, avisos, información y otras
          comunicaciones que le proporcionamos electrónicamente cumplan con
          cualquier requisito legal que dichas comunicaciones cumplirían por
          escrito.
        </p>
    </div>

    <div>
      <h3>Propiedad intelectual</h3>
       <p>
        <u>Derechos de autor</u>. 
        Todo texto, gráfico, logotipo, sonido,
          descarga, software, ícono de botón, material adicional y el diseño
          general del Sitio (en conjunto, el "Contenido") que esté incluido o
          disponible a través del Sitio está protegido por derechos de autor por
          parte de Access Corrections o nuestros proveedores de contenido, y
          está protegido por Estados Unidos o las leyes internacionales de
          derechos de autor. Todos los derechos reservados. Usted puede imprimir
          una copia del Contenido en su computadora solamente para su uso
          personal, no comercial, siempre que no elimine ninguna marca
          registrada ni derechos de autor u otros avisos que indiquen propiedad
          del Contenido. Cualquier otro uso del Contenido está estrictamente
          prohibido, a menos que tenga un permiso previo por escrito.
        </p>
        <u>
           Notificación y procedimiento para presentar reclamos de infracción
            de derechos de autor.
        </u>
        Access Corrections respeta la propiedad intelectual de terceros. Si
          usted cree que su trabajo se ha copiado de forma que constituye una
          infracción a los derechos de autor, póngase en contacto con el
          Departamento Legal de Access Corrections en TKC Holdings, Inc.,
          Intellectual Property Questions, 1260 Andes Boulevard, St. Louis,
          Misuri, 63132. Incluya lo siguiente: (1) una firma física de la
          persona autorizada para actuar en nombre del propietario del derecho
          de autor u otro interés de propiedad; (2) una descripción de la obra
          protegida por derechos de autor u otro material protegido que usted
          alegue que se ha infringido; (3) una descripción de dónde se encuentra
          el material en el Sitio; (4) su dirección, número de teléfono y
          dirección de correo electrónico; (5) su declaración de que usted cree
          de buena fe que el uso en disputa no está autorizado por el
          propietario de los derechos de autor u otros intereses, su agente o la
          ley; y (6) su declaración, hecha bajo pena de perjurio, de que la
          información en su notificación es exacta y que usted es el propietario
          de los derechos de autor o de otros intereses o está autorizado para
          actuar en nombre de su propietario.
        <p>    
        <u>Marcas registradas</u>. 
        ACCESS CORRECTIONS, ACCESS SECURE DEPOSIT y
          ACCESS SECURE MAIL están incluidas en la familia de marcas registradas
          y marcas de servicio propiedad de Access Corrections en los Estados
          Unidos y otros países (esta no es una lista completa de las marcas
          registradas y marcas de servicio de Access Corrections). Las marcas
          registradas y de servicio de Access Corrections no pueden utilizarse
          en conexión con ningún producto o servicio que no sea de Access
          Corrections de ninguna manera que pueda causar confusión entre los
          clientes, que menosprecie o desacredite a Access Corrections, o sin
          nuestro consentimiento previo por escrito. Todas las demás marcas
          registradas que no sean propiedad de Access Corrections que aparezcan
          en el Sitio son propiedad de sus respectivos propietarios, que pueden
          o no estar afiliados, conectados o patrocinados por Access
          Corrections.
        </p>
    </div>

    <div>
      <h3>Su cuenta</h3>
      <p>Si utiliza el Sitio, usted es responsable de mantener la
          confidencialidad de su cuenta y su contraseña, y de restringir el
          acceso a su computadora, así como usted acepta la responsabilidad de
          todas las actividades que ocurran en su cuenta o con su contraseña.
          Para utilizar los servicios debe tener al menos dieciocho (18) años de
          edad y ser capaz de celebrar un contrato vinculante según la ley
          aplicable. Access Corrections se reserva el derecho de rechazar la
          prestación del servicio, cancelar cuentas, eliminar o editar
          contenido, o cancelar pedidos a su entera discreción. Si su cuenta
          permanece inactiva (es decir, no se realizan inicios de sesión ni
          pagos desde su cuenta) durante un período de tiempo prolongado, Access
          Corrections se reserva el derecho de desactivar su cuenta. En caso de
          que su cuenta esté inactiva y se considere "no reclamada" o
          "abandonada" según la ley de su estado, Access Corrections le enviará
          un aviso según lo exija la ley aplicable. Tenga en cuenta que si su
          cuenta se desactiva por algún motivo, deberá abrir una nueva cuenta
          antes de utilizar el Servicio de Access Corrections.
        </p>
    </div>

    <div>
      <h3>Uso de la información enviada</h3>
        <p>
        Para ayudar al Gobierno a combatir el financiamiento del terrorismo y
          las actividades de lavado de dinero, la ley federal nos exige obtener,
          verificar y registrar información que identifique a cada persona que
          se dedique a los servicios financieros con Keefe Commissary Network,
          LLC. Al realizar esta operación, le pediremos su nombre, dirección y
          otra información que nos permita identificarlo. Si no proporciona toda
          la información solicitada, se puede retrasar o rechazar su Pago.
        </p>
        <p>
        Usted acepta que Access Corrections es libre de utilizar cualquier
          comentario, información o idea que figure en cualquier comunicación
          que usted nos envíe sin compensación, reconocimiento o pago a usted,
          para cualquier propósito, lo que incluye, entre otros, desarrollar,
          fabricar y comercializar productos y servicios, o modificar/mejorar el
          Sitio u otros productos o servicios.
        </p>
        <p>
      Access Corrections se reserva el derecho de verificar la información
          de facturación proporcionada luego de que usted autorice la
          transacción y antes de que los fondos lleguen al destinatario. Como
          parte de este proceso, nuestro personal podría ponerse en contacto con
          usted.
        </p>
        <p>
        Tenga en cuenta que, si se lo selecciona para nuestro proceso de
          verificación y no responde a las solicitudes que nuestro personal
          realice por teléfono, su transacción se puede cancelar a nuestra sola
          discreción. En el caso de que su tarjeta de crédito se cancele, usted
          recibirá un reembolso completo por el monto que pretendía enviar a
          través de Access Corrections.
        </p>
    </div>

    <div>
      <h3>
        Renuncia de garantías y limitación de responsabilidad
      </h3>
      <p>ACCESS CORRECTIONS PROVEE ESTE SITIO Y EL SERVICIO DE ACCESS
          CORRECTIONS TAL COMO SON Y COMO ESTÁN DISPONIBLES. ACCESS CORRECTIONS
          NIEGA TODA GARANTÍA, EXPRESA O IMPLÍCITA, EN CUANTO AL FUNCIONAMIENTO
          DE ESTE SITIO, LA INFORMACIÓN, EL CONTENIDO, LOS MATERIALES, PRODUCTOS
          O SERVICIOS INCLUIDOS EN ESTE SITIO. USTED ACEPTA QUE EL USO DE ESTE
          SITIO Y DEL SERVICIO DE ACCESS CORRECTIONS ES BAJO SU PROPIO RIESGO Y
          QUE USTED ES EL ÚNICO RESPONSABLE DE LA EXACTITUD DE LA INFORMACIÓN
          PERSONAL Y DE PAGO QUE USTED PROPORCIONA. EN LA MAYOR MEDIDA PERMITIDA
          CONFORME A LA LEY APLICABLE, ACCESS CORRECTIONS RECHAZA TODAS LAS
          GARANTÍAS, EXPRESAS O IMPLÍCITAS, INCLUIDAS, ENTRE OTRAS, LAS
          GARANTÍAS DE COMERCIALIZACIÓN Y DE APTITUD PARA UN PROPÓSITO
          PARTICULAR. ACCESS CORRECTIONS NO GARANTIZA QUE ESTE SITIO, EL
          SERVICIO DE ACCESS CORRECTIONS O LOS CORREOS ELECTRÓNICOS ENVIADOS
          DESDE ACCESS CORRECTIONS SE ENCUENTREN LIBRES DE VIRUS U OTROS
          COMPONENTES DAÑINOS.
        </p>
        <p> 
       ACCESS CORRECTIONS (ASÍ COMO SUS FUNCIONARIOS, DIRECTORES, EMPLEADOS,
          AFILIADOS Y ACCIONISTAS) NO SERÁN RESPONSABLES POR DAÑOS DE CUALQUIER
          TIPO DERIVADOS DE LA UTILIZACIÓN DE ESTE SITIO, DE LA NO AUTORIZACIÓN
          DEL PAGO CON UNA TARJETA BANCARIA DEL USUARIO POR PARTE DE LA COMPAÑÍA
          DE LA TARJETA DE CRÉDITO, POR INTERRUPCIONES DEL SERVICIO EN ESTE
          SITIO, O POR ERRORES, DEMORAS O ENVÍOS INCORRECTOS DE UN PAGO,
          INDEPENDIENTEMENTE DE LA CAUSA, LO QUE INCLUYE, ENTRE OTROS, DAÑOS
          DIRECTOS, INDIRECTOS, FORTUITOS, PUNITIVOS Y CONSECUENTES. CIERTAS
          LEYES ESTATALES NO PERMITEN LIMITACIONES SOBRE LAS GARANTÍAS
          IMPLÍCITAS O LA EXCLUSIÓN O LIMITACIÓN DE CIERTOS DAÑOS. SI ESTAS
          LEYES SON APLICABLES A SU CASO, ALGUNAS O TODAS LAS RENUNCIAS,
          EXCLUSIONES O LIMITACIONES ANTERIORMENTE MENCIONADAS PUEDEN NO SER
          APLICABLES A SU CASO, E INCLUSO PODRÍA TENER DERECHOS ADICIONALES.
        </p>
    </div>

    <div>
      <h3>Indemnización</h3>
      <p> Usted se compromete a indemnizar y mantener a Access Corrections y a
          sus compañías relacionadas y a cada uno de sus respectivos directores,
          funcionarios, empleados y agentes indemnes de y contra cualquier
          reclamo o causa de acción de terceros, incluyendo los honorarios y
          costos razonables de abogados que surjan, directa o indirectamente,
          total o parcialmente, fuera de su acceso o uso del Sitio, su violación
          de estos Términos y condiciones, su uso del Servicio de Access
          Corrections y su violación de cualquier ley o los derechos de
          cualquier persona.
      </p>
    </div>

    <div>
      <h3>Impugnaciones</h3>
      <p> Estos Términos y condiciones se regirán e interpretarán en conformidad
          con las leyes del estado de Misuri, Estados Unidos de América, sin
          considerar su conflicto con los principios legales. Cualquier acción
          para hacer cumplir estos Términos y condiciones se deberá interponer
          ante la corte federal del distrito este de Misuri o los tribunales
          estatales ubicados en el condado de St. Louis, Misuri. Al utilizar el
          Sitio, usted se somete a la jurisdicción y al fuero de estos
          tribunales. Excepto en donde esté prohibido, usted acepta que
          cualquiera y todas las impugnaciones, reclamos y causas de la acción
          que surjan directa o indirectamente del Sitio se resolverán
          individualmente, sin recurrir a ninguna forma de demanda colectiva.
          Cualquier reclamo o causa de la acción que pueda tener con respecto al
          Sitio o el Servicio de Access Corrections se deberá iniciar dentro de
          un (1) año después de que haya surgido el reclamo o la causa de la
          acción, independientemente de cualquier ley que disponga lo contrario.
        </p>
    </div>

    <div>
      <h3>Disposiciones generales</h3>
      <p>  Si alguna disposición de estos Términos y condiciones se considera
          inválida o inejecutable, dicha disposición se interpretará en
          conformidad con la ley aplicable y se exigirá el cumplimiento de las
          demás disposiciones. Los encabezados se incluyen con fines de
          referencia únicamente y de ninguna manera definen, limitan,
          interpretan o describen el alcance de la sección. Nuestra incapacidad
          para hacer cumplir cualquier disposición de estos Términos y
          condiciones no constituirá una renuncia a esta o cualquier otra
          disposición. Estos Términos y condiciones, incorporados en este
          documento por esta referencia, exponen el acuerdo completo entre usted
          y Access Corrections en relación al uso que usted haga del Sitio y del
          Servicio de Access Corrections.
        </p>
    </div>
	
	<div>
	<h3>Actividades fraudulentas o en disputa</h3>
      <p>  Usted acepta que podemos rechazar o impedir transacciones hacia su
          cuenta o desde ella para protegerlo a usted o a nosotros, o para
          cumplir con requisitos legales o reglamentarios. Estas acciones
          incluyen, entre otras, retrasar cualquier transferencia específica de
          fondos a su cuenta o retiro, pago o transferencia de fondos de su
          cuenta en espera de una investigación adicional, limitar la capacidad
          del depositante para depositar más fondos, restringir al destinatario
          la posibilidad de recibir transacciones futuras, congelar su cuenta y
          debitar fondos de su cuenta (hasta el monto total de todos los fondos
          en nuestra cuenta) en cualquiera de las siguientes circunstancias:
        </p>
		<ol type="a">
          <li>
            Sospechamos que usted puede ser víctima de un fraude, estafa o
            explotación financiera, aunque haya autorizado las transacciones.
          </li>
          <li>
            Sospechamos que cualquier transacción puede implicar actividad
            ilegal o puede ser fraudulenta.
          </li>
          <li>
            Cumplimos, a nuestro exclusivo criterio, con cualquier ley, norma o
            regulación federal, estatal o local, incluidas las normas federales
            de control y sanción de activos y las normas contra el lavado de
            dinero, o con las políticas que hemos adoptado para garantizar que
            cumplimos con esas leyes, normas o regulaciones.
          </li>
          <li>Una transacción en disputa que resulta en una devolución. </li>
          <li>
            Creemos de forma razonable que hacerlo es necesario para evitar una
            pérdida o reducir el riesgo para nosotros.
          </li>
        </ol>
		<p>
		También nos reservamos el derecho de debitar su cuenta para recuperar
          los costos incurridos por la transacción fraudulenta o en disputa. Si
          su cuenta no puede recibir fondos según lo dispuesto anteriormente,
          usted acepta que cualquier pago o transferencia de fondos a su cuenta
          se aplicará primero para reembolsarnos todas las transacciones
          fraudulentas o en disputa recibidas por el destinatario junto con
          cualquier tarifa relacionada y los costos incurridos por nosotros para
          dichas transacciones.
		</p>
		<p>
		Sin perjuicio de la ley aplicable, no seremos responsables de ninguna
          acción que tomemos en virtud de esta sección.
		</p>
	</div>

    <div>
      <h3>Contáctenos</h3>
      <p> Si tiene alguna pregunta acerca de estos Términos y condiciones,
          póngase en contacto con nosotros en
        <a class="ot-btn-anchor" href="mailto:customerservice@accesscorrections.com">
          customerservice@accesscorrections.com.
        </a>
        </p>
    </div>
  </div>
`,
  affirmativeButton: { color: "primary", caption: "Close" },
};

export const PrivacyPolicyDialogEnglish: DialogChildren = {
  open: true,
  title: "PRIVACY POLICY",
  subtitle: "",
  replaceId: "replaceId",
  affirmativeButton: { color: "primary", caption: "Close" },
  content: `

  <h1>PRIVACY POLICY</h1>

  <div id="replaceId">
    <h2>Effective Date: December 31, 2023 </h2>
  </div>
  <hr>
</div>
<p> This Privacy Policy explains and governs the manner in which TKC
        Holdings, Inc. and its subsidiaries (collectively referred to herein as
        “TKC”), collects, uses, maintains, and discloses information related to
        your use of our services. By using our services, you are agreeing to the
        policies and practices described in this Privacy Policy. This Privacy
        Policy may change from time to time. When changes are made, we will
        update the “Last Modified and Effective” date at the top of this Privacy
        Policy and, in some cases, we may provide additional notice as described
        below. Your continued use of our services after we make changes is
        deemed to be acceptance of those changes, so please check the Privacy
        Policy for updates. If you do not consent to these policies and
        practices, please do not use the website or services.</p>

<h2>This Policy describes:</h2>
<ul>
  <li>Personal Information and Data We Collect; </li>
          <li>How We Collect Your Personal Information and Data;</li>
          <li>How We Use Your Personal Information and Data;</li>
          <li>
            How We Share Your Personal Information and Data With Third Parties;
          </li>
          <li>How We Protect Your Information and Data;</li>
          <li>California Privacy Rights;</li>
          <li>Colorado Privacy Rights;</li>
          <li>Connecticut Privacy Rights;</li>
          <li>Utah Privacy Rights;</li>
          <li>Virginia Privacy Rights;</li>
          <li>Non-Discrimination Rights;</li>
          <li>Identification Verification;</li>
          <li>Children’s Privacy;</li>
          <li>Changes to the Policy; </li>
          <li>How to Update Your Information and Manage Communications;</li>
          <li>Contact for More Information; and</li>
          <li>the California Employee Privacy Notice</li>
</ul>

<h2>Personal Information and Data We Collect </h2>

 <p>
          “Personal Data,” means any information that is linked or reasonably
          linkable to an identified or identifiable natural person. "Personal
          data" does not include de-identified data or publicly available
          information.
        </p>
        <p>
          "Sensitive data," means a category of personal data that includes: 1.
          Personal data revealing racial or ethnic origin, religious beliefs,
          mental or physical health diagnosis, sexual orientation, or
          citizenship or immigration status; 2. The processing of genetic or
          biometric data for the purpose of uniquely identifying a natural
          person; 3. The personal data collected from a known child; or 4.
          Precise geolocation data.
        </p>
        <p>
          “Personal Information,” means any information that identifies, relates
          to, describes, is reasonably capable of being associated with, or
          could reasonably be linked, directly or indirectly, to any individual
          or a household. It does not include anonymous or aggregated data that
          cannot be associated with an individual or household.
        </p>
        <p>
          “Sensitive Personal Information” means Personal information that
          reveals a consumer’s social security, driver’s license, state
          identification card, or passport number. A consumer’s account log-in,
          financial account, debit card, or credit card number in combination
          with any required security or access code, password, or credentials
          allowing access to an account. A consumer’s precise geolocation; a
          consumer’s racial or ethnic origin, religious or philosophical
          beliefs, or union membership. The contents of a consumer’s mail,
          email, and text messages unless the business is the intended recipient
          of the communication. A consumer’s genetic data. The processing of
          biometric information for the purpose of uniquely identifying a
          consumer. Personal information collected and analyzed concerning a
          consumer’s health. Personal information collected and analyzed
          concerning a consumer’s sex life or sexual orientation. Sensitive
          personal information that is “publicly available” shall not be
          considered Sensitive Personal Information or Personal Information.
        </p>
        <p>
          We may collect, use, store, and transfer different kinds of Personal
          Information & Data, and Sensitive Personal Information & Data about
          you. The categories of information and data collected may include the
          following (many of these categories are only collected for individuals
          employed by TKC Holdings, Inc. or its subsidiaries):
        </p>
        <ul>
          <li>
            
            <strong>Identifiers</strong>, such as name, alias, postal address,
            unique personal identifier, online identifier, Internet Protocol
            (IP) address, email address, account name, social security number,
            driver’s license number, passport number, or other similar
            identifiers;
          </li>
          <li>
            
            <strong>
              Characteristics of protected classifications under California or
              federal law,
            </strong>
             including age or date of birth, national origin, disability,
            citizenship, military status;
          </li>
          <li>
            
            <strong>Biometric information,</strong> including hair color, eye
            color, fingerprints, height, retina scans, facial recognition,
            voice, and other biometric data;
          </li>
          <li>
            
            <strong>
              Internet or other electronic network activity information,
            </strong>
            including browsing history, search history, and information
            regarding a consumer’s interaction with an Internet website,
            application, or advertisement;
          </li>
          <li>
            
            <strong>Geolocation data</strong>, which includes any kind of data
            that allows for determining, with reasonable precision, your
            location;
          </li>
          <li>
            
            <strong>Professional or employment-related information;</strong>
          </li>
          <li>
            
            <strong>Education information;</strong>
          </li>
          <li>
            
            <strong>
              Inferences drawn from any of the information identified in this
              subdivision to create a profile about a consumer reflecting the
              consumer’s preferences, characteristics, psychological trends,
              predispositions, behavior, attitudes, intelligence, abilities, and
              aptitudes;
            </strong>
          </li>
          <li>
            
            <strong>
              Personal information that reveals your social security, driver’s
              license, state identification card, or passport number;
            </strong>
          </li>
          <li>
            
            <strong>
              Personal information collected and analyzed concerning a
              consumer’s health.
            </strong>
          </li>
        </ul>

<h3>How We Collect Your Personal Information and Data</h3>

        <p>
          We may collect Personal Information and Data from a variety of sources
          and methods. This includes:
        </p>
        <ul>
          <li>
            <strong>Information You Voluntarily Provide</strong>
          </li>

          <p>
            You may give us your Personal Information and Data by filling in
            forms or by corresponding with us by mail, phone, email, or
            otherwise. This includes Personal Information and Data you provide
            when you:
          </p>
          <ol>
            <li>
              Submit a Request More Information or Contact Us form on our
              website
            </li>
            <li>Submit a message through our website</li>
            <li>Send funds or make payments through our service</li>
            <li>Send emails through our service</li>
            <li>Call, email, fax, text, chat or write to us</li>
            <li>Create an account</li>
            <li>Purchased services</li>
            <li>Order goods</li>
          </ol>

          <li>
            <strong>Information We Collect When You Use Our Services</strong>
          </li>

          <p>
            <u>Information Automatically Collected</u>
          </p>
          <p>
            When you visit our website, our web server automatically collects
            your Internet protocol (IP) address, which is a number assigned to
            your computer when you connect to the Internet. Our web server may
            also be able to identify things like the type of web browser,
            operating system you use, internet service provider (ISP),
            referring/exit pages, operating system, date/time stamp, and/or
            clickstream data. When you access and use our services from your
            mobile devices, we receive data from that mobile device. This may
            include your location data, IP address and device type. We can and
            will use IP addresses to identify a user when necessary to enforce
            compliance with the website Terms and Conditions.
          </p>

          <p>
            <u>Use of Cookies</u>
          </p>
          <p>
            Cookies are small files that we or our service provider transfer to
            your computer’s hard drive through your web browser that enables us
            or our service provider’s systems to recognize your browser and
            capture and remember certain information. We use cookies to analyze
            movement on the website, such as total visitors to the website and
            pages viewed, for fingerprinting, site security, and to make
            improvements to the website. Moreover, our website’s partners may
            also use cookies in connection with the services and websites to
            which our website links. Most web browsers are initially set up to
            receive cookies. If you do not want to receive cookies, browsers
            usually have a “Help” or “Internet Tools” feature that will show you
            how to prevent your browser from accepting new cookies and how to
            delete cookies from your computer. If you reject cookies, you may
            still use our website, but your ability to use some features or
            areas of our website may be limited. For more information about
            cookies, please visit <a class="ot-btn-anchor" href="http://www.allaboutcookies.org"
          target="blank">www.allaboutcookies.org</a>. </p>
          <p>
            We use third party tools included but not limited to protection
            tools provided by Google and CloudFlare to assist us in better
            understanding our website visitors. These tools collect IP address
            and usage data, such as the length of time a user spends on a page,
            the pages a user visits, and the websites a user visits before and
            after visiting our website. Based on this information, these
            providers compile aggregated data about website traffic and
            interactions, which we use to offer better user experiences and
            tools in the future. For more information visit Google or
            CloudFlare’s Privacy and Terms.
          </p>
          <li>
            <strong>Information We Collect From Third Parties</strong>
          </li>
          <p>
            We may collect Personal Information and Data from other sources
            including our trusted partnerships with service providers. The
            collection, use, and disclosure of Personal Information and Data
            received from third parties is governed by the privacy policies
            listed on the website where the information was submitted by the
            user. Third parties may send their own cookies and pixel tags to
            you, and may collect information and use it in a way inconsistent
            with this Policy. Please carefully review these third-party privacy
            policies to understand how your information may be collected, used,
            and disclosed by these third parties.
          </p>
        </ul>

<h3>How We Use Your Personal Information and Data</h3>
 </p>
        <p>
          TKC uses information we collect about you or that you provide to us,
          including Personal Information and Data, for the following business
          purposes:
        </p>
        <ul>
          <li>
            To provide you with our products and services, and to operate our
            business.
          </li>
          <li>
            To communicate with you and answer specific questions related to
            products and services offered.
          </li>
          <li>
            To learn more about how visitors use the website (data analysis) and
            measure areas of interest for the purpose of improving the website,
            products, and services.
          </li>
          <li>
            For our internal marketing purposes, which include, but are not
            limited to, sending you material about products, services, updates,
            etc. that we think may be of interest to you.
          </li>
          <li>
            Enhancing the safety and security of the website, preventing
            potentially fraudulent, prohibited, or illegal activities, and
            enforcing our Terms and Conditions.
          </li>
          <li>Resolving disputes and troubleshooting problems.</li>
          <li>
            Responding to requests by government entities, in connection with an
            investigation of suspected or actual unlawful activity, and other
            duties as required by law.
          </li>
          <li>
            For any other purposes disclosed at the time you provide your
            information or as otherwise set forth in this Policy.
          </li>
        </ul>
        <p>
          TKC does not use or disclose sensitive personal information for
          purposes other than those specified in section 7027(m) of the
          California Consumer Privacy Act (“CCPA”) regulations.
        </p>

<h3>How We Share Your Personal Information and Data With Third Parties</h3>
 <p>
          We share information related to your account and purchase(s) in the
          following circumstances:
        </p>
        <ul>
          <li>
            <strong>Service Providers</strong>. We contract with third parties
            to provide services that allow us to operate our business. Your
            Personal Information and Data may be disclosed to these third-party
            service providers in order for us to provide you with our services
            and products. Third party services include, but are not limited to,
            (1) supporting your use of our website, (2) providing operational,
            marketing or advertising support, and/or (3) other purposes to
            support our business, such as analyzing data. Service Providers are
            permitted to use your information only on our behalf as specified in
            the vendor contract.
          </li>
          <li>
            <strong>For Security Purposes</strong>. For some of our products, in
            order for our services to be effectuated we are required to disclose
            limited personal information that you have provided us to a
            correctional facility, who must review this information for security
            purposes. Additionally, the end-recipient of the services or
            products you purchase may be required to receive limited personal
            information, so that they may consent to the receipt of the services
            or products at issue.
          </li>
          <li>
            <strong>Legal Process</strong>. Subject to applicable law, we may
            disclose information about you (i) if we are required to do so by
            law, regulation, or legal process, such as a subpoena; (ii) in
            response to requests by government entities, such as law enforcement
            authorities; (iii) when we believe disclosure is necessary or
            appropriate to prevent physical, financial or other harm, injury or
            loss; or (iv) in connection with an investigation of suspected or
            actual unlawful activity.
          </li>
          <li>
            <strong>Internal Third Parties</strong>. We may share Personal
            Information and Data with our parent company TKC Holdings, Inc. and
            other companies owned by or controlled by TKC Holdings, Inc., who
            may use the Personal Information and Data for the purposes described
            herein.
          </li>
          <li>
            <strong>Business Transactions</strong>. Third parties to whom we may
            choose to sell, transfer, or merge parts of our business or our
            assets. Alternatively, we may seek to acquire other businesses or
            merge with them. If a change happens to our business, then the new
            owners may use your Personal Information and Data in the same way as
            set out in this Privacy Policy.
          </li>
          <li>
            <strong>Website Security</strong>. We use products by Google and
            CloudFlare to protect our website from various types of abusive
            processing attempts. In order for these tools to work, they analyze
            various information they collect from each visitor, which may
            include the IP address, mouse movements, length of stay, and other
            information. This data is sent to Google or CloudFlare to determine
            whether the visitor is a natural person or an abusive automated
            program (<i>e.g.</i>, bot). For more information visit Google or
            CloudFlare’s Privacy and Terms.
          </li>
        </ul>
<h3>How We Protect Your Information</h3>
<p>
          We endeavor to incorporate physical, technical, and administrative
          safeguards and policy methods to protect your personally identifiable
          information. It is also important that you take steps to maintain the
          secrecy of your account information and secure access to your
          computer. Always be sure to log out of your account when using a
          shared or public computer. Please be aware that no data transmission
          over the Internet, mobile networks, wireless transmission or
          electronic storage of information can be guaranteed to be 100% secure.
          Therefore, we cannot guarantee its absolute security. It may be
          possible for third parties to intercept or access transmissions or
          private communications unlawfully. Any such transmission is done at
          your own risk.
        </p>
<h3>California Privacy Rights</h3>
 <p>
          If you are a California resident, the California Consumer Privacy Act
          (CCPA) provides you with certain additional privacy rights related to
          the Personal Information TKC collects or has collected about you.
          Please see below to learn more about your rights under the CCPA.
        </p>
        <ul>
          <li>
            <strong>Request to Know</strong>
          </li>
          <p>
            You may request no more than twice in any 12-month period and,
            subject to verification of your identity and certain exemptions, we
            will provide:
          </p>
          <ol>
            <li>
              
              The categories of Personal Information we collected about you.
            </li>
            <li>
              
              The categories of sources from which the Personal Information is
              collected.
            </li>
            <li>
              
              The categories of Personal Information sold or shared for purposes
              of cross-contextual advertising to a third party, as well as the
              categories of third parties to whom such personal information was
              disclosed, by category of categories of personal information for
              each category of third party.
            </li>
            <li>
              
              The categories of Personal Information that the business disclosed
              about the consumer for a business purpose and the categories of
              persons to whom it was disclosed for a business purpose.
            </li>
            <li>
              
              Our business or commercial purpose for collecting, selling, or
              sharing for purposes of cross-contextual advertising your Personal
              Information.
            </li>
            <li>
              
              The specific pieces of Personal Information we collected about
              you.
            </li>
          </ol>
          <li>
            <strong>Request to Delete</strong>
          </li>
          <p>
            You may request that we delete Personal Information we have
            collected from you, subject to verification of your identity. Please
            note, that some information may not be eligible for deletion based
            upon applicable law or requirements of customer contracts.
          </p>
          <li>
            <strong>Request to Correct</strong>
          </li>
          <p>
            You may request that we correct inaccurate Personal Information we
            have collected from you, subject to verification of your identity
            and exceptions provided by law.
          </p>
          <li>
            <strong>Request Not to Sell or Share Personal Information</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Information
            and Sensitive Personal Information sold to third parties or shared
            to third parties for purposes of cross-contextual advertising.
            However, TKC does not sell Personal Information or Sensitive
            Information nor does TKC share Personal Information or Sensitive
            Personal Information with third parties for purposes of
            cross-contextual advertising. TKC has no actual knowledge of any
            sales of Personal Information or Sensitive Personal Information of
            minors under 16 years of age.
          </p>
          <li>
            <strong>Request to Limit Use and Disclosure</strong>
          </li>
          <p>
            You may request that we limit the use and disclosure of your
            Sensitive Personal Information. However, TKC does not collect
            Sensitive Personal Information.
          </p>
          <li>
            <strong>Exercising Your CCPA Rights</strong>
          </li>
          <p>
            If you are a California resident and would like to submit a CCPA
            request, you or your authorized agent may:
          </p>
          <ol>
            <li> Contact us by phone at 1-844-475-7190, or</li>
            <li>
              
              Initiate a request by completing our online form which can be
              located here
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Exercise Your Rights</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Powered by</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
 <p>
            Please note that these rights apply to select California consumers.
            Only you, or an agent you authorize to act on your behalf may make a
            verifiable consumer request related to your Personal Information. To
            authorize another person to make a verifiable request on your
            behalf, you must provide that person with written permission clearly
            describing their authority to make a request on your behalf. That
            agent must also be able to verify their identity with us and provide
            us with their authority to act on your behalf. An individual to whom
            you have provided Power of Attorney pursuant to Sections 4000 – 4465
            of the California Probate Code may also make a request on your
            behalf. If your request is denied, you will be provided with a
            method to appeal this finding.
          </p>

          <li>
            <strong>Other California Privacy Rights.</strong>
          </li>
          <p>
            <u>California Civil Code Section 1798.83</u> permits California
            residents who have provided personally identifiable information to
            us or our third-party advertisers and marketing partners, if any, to
            request certain information regarding our disclosure of personally
            identifiable information to third parties for direct marketing
            purposes. We do not share information we collect about you with
            third parties for those third parties’ direct marketing purposes.
          </p>
          <p>
            <u>Your ‘Do Not Track’ Browser Setting</u>. Some web browsers
            incorporate a “Do Not Track” feature (DNT) that signals to the
            websites that you visit that you do not want to have your online
            activity tracked. Many websites and applications, including ours, do
            not currently respond to web browser DNT signals because such
            signals are not yet uniform. For more information about DNT signals,
            please visit <a class="ot-btn-anchor" href="http://allaboutdnt.com" target="blank">http://allaboutdnt.com.</a>  Other third-party websites may keep track of your browsing
            activities when they provide you with content, which enables them to
            customize what they present to you on their websites.</p>
</ul>
<h3>Colorado Privacy Rights</h3>
<p>
          If you are a Colorado resident, the Colorado Privacy Act (CPA)
          provides you with certain additional privacy rights related to the
          Personal Data TKC collects about you. Please see below to learn more
          about your rights under the CPA.
        </p>
        <ul>
          <li>
            <strong>Request to Access</strong>
          </li>
          <p>
            You have the right to confirm whether or not TKC is processing your
            Personal Data. You also have the right to access your Personal Data
            processed by TKC. You may request no more than twice annually, free
            of charge, that we provide easy, portable access to all Personal
            Data held by TKC, subject to verification of your identity and
            exceptions provided by law.
          </p>
          <li>
            <strong>Request to Correct</strong>
          </li>
          <p>
            You may request that we correct inaccurate Personal Data we have
            collected from you, subject to verification of your identity and
            exceptions provided by law.
          </p>
          <li>
            <strong>Request to Delete</strong>
          </li>
          <p>
            You may request that we delete Personal Information we have
            collected from you, subject to verification of your identity. Please
            note, that some information may not be eligible for deletion based
            upon applicable law or requirements of customer contracts.
          </p>
          <li>
            <strong>
              Request Not to Process Personal Data for Targeted Advertising
            </strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data
            processed for the purposes of Targeted Advertising. However, TKC
            does not utilize Personal Data for the purposes of Targeted
            Advertising.
          </p>
          <li>
            <strong>Request Not to Sell Personal Data</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data sold to
            third parties. However, TKC does not sell Personal Data. TKC has no
            actual knowledge of any sales of Personal Data of children under 13
            years of age.
          </p>
          <li>
            <strong>Request Not to Profile based on Personal Data</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data used
            for automated processing to evaluate, analyze, or predict personal
            aspects related to your identified or identifiable economic
            situation, health, personal preferences, interests, reliability,
            behavior, location, or movements. However, TKC does not utilize
            Personal Data for the purposes of Profiling.
          </p>
          <li>
            <strong>Exercising Your CPA Rights</strong>
          </li>
          <p>
            If you are a Colorado resident and would like to submit a CPA
            request, you may:
          </p>
          <ol>
            <li> Contact us by phone at 1-844-475-7190, or</li>
            <li>
              
              Initiate a request by completing our online form which can be
              located here
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Exercise Your Rights</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Powered by</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
   <p>
            Please note that these rights apply only to select Colorado
            consumers and currently exclude job applicants, employees, and
            business contacts. Only you may make a verifiable consumer request
            related to your Personal Data. If your request is denied, you will
            be provided with a method to appeal this finding.
          </p>
</ul>
<h3>Connecticut Privacy Rights</h3>
<p>
          If you are a Connecticut resident, the Connecticut Data Privacy Act
          (CTDPA) provides you with certain additional privacy rights related to
          the Personal Data TKC collects about you. Please see below to learn
          more about your rights under the CTDPA.
        </p>
        <ul>
          <li>
            <strong>Request to Access</strong>
          </li>
          <p>
            You have the right to confirm whether or not TKC is processing your
            Personal Data. You also have the right to access your Personal Data
            processed by TKC. You may request no more than once annually, free
            of charge, that we provide easy, portable access to all Personal
            Data held by TKC, subject to verification of your identity and
            exceptions provided by law.
          </p>
          <li>
            <strong>Request to Correct</strong>
          </li>
          <p>
            You may request that we correct inaccurate Personal Data we have
            collected from you, subject to verification of your identity and
            exceptions provided by law.
          </p>
          <li>
            <strong>Request to Delete</strong>
          </li>
          <p>
            You may request that we delete Personal Information we have
            collected from you, subject to verification of your identity. Please
            note, that some information may not be eligible for deletion based
            upon applicable law or requirements of customer contracts.
          </p>
          <li>
            <strong>
              Request Not to Process Personal Data for Targeted Advertising
            </strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data
            processed for the purposes of Targeted Advertising. However, TKC
            does not utilize Personal Data for the purposes of Targeted
            Advertising, including the Personal Data of minors under 18 years of
            age.
          </p>
          <li>
            <strong>Request Not to Sell Personal Data</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data sold to
            third parties. However, TKC does not sell Personal Data, including
            the Personal Data of minors under 18 years of age.
          </p>
          <li>
            <strong>Request Not to Profile based on Personal Data</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data used
            for automated processing to evaluate, analyze, or predict personal
            aspects related to your identified or identifiable economic
            situation, health, personal preferences, interests, reliability,
            behavior, location, or movements. However, TKC does not utilize
            Personal Data for the purposes of Profiling, including the Personal
            Data of minors under 18 years of age.
          </p>
          <li>
            <strong>Exercising Your CTDPA Rights</strong>
          </li>
          <p>
            If you are a Connecticut resident and would like to submit a CTDPA
            request, you may:
          </p>
          <ol>
            <li> Contact us by phone at 1-844-475-7190, or</li>
            <li>
              
              Initiate a request by completing our online form which can be
              located here
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Exercise Your Rights</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Powered by</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
   <p>
            Please note that these rights apply only to select Connecticut
            consumers and currently exclude job applicants, employees, and
            business contacts. Only you may make a verifiable consumer request
            related to your Personal Data. If your request is denied, you will
            be provided with a method to appeal this finding.
          </p>
</ul>

<h3>Utah Privacy Rights</h3>
<p>
          If you are a Utah resident, the Utah Consumer Privacy Act (UCPA)
          provides you with certain additional privacy rights related to the
          Personal Data TKC collects about you. Please see below to learn more
          about your rights under the UCPA.
        </p>
        <ul>
          <li>
            <strong>Request to Access</strong>
          </li>
          <p>
            You have the right to confirm whether or not TKC is processing your
            Personal Data. You also have the right to access your Personal Data
            processed by TKC. You may request no more than twice in a twelve
            (12) month period, free of charge, that we provide easy, portable
            access to all Personal Data held by TKC, subject to verification of
            your identity and exceptions provided by law.
          </p>
          <li>
            <strong>Request to Delete</strong>
          </li>
          <p>
            You may request that we delete Personal Information we have
            collected from you, subject to verification of your identity. Please
            note, that some information may not be eligible for deletion based
            upon applicable law or requirements of customer contracts.
          </p>
          <li>
            <strong>
              Request Not to Process Personal Data for Targeted Advertising
            </strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data
            processed for the purposes of Targeted Advertising. However, TKC
            does not utilize Personal Data for the purposes of Targeted
            Advertising.
          </p>
          <li>
            <strong>Request Not to Sell Personal Data</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data sold to
            third parties. However, TKC does not sell Personal Data.
          </p>
          <li>
            <strong>Exercising Your UCPA Rights</strong>
          </li>
          <p>
            If you are a Utah resident and would like to submit a UCPA request,
            you may:
          </p>
          <ol>
            <li> Contact us by phone at 1-844-475-7190, or</li>
            <li>
              
              Initiate a request by completing our online form which can be
              located here
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Exercise Your Rights</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Powered by</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
   <p>
            Please note that these rights apply only to select Utah consumers
            and currently exclude job applicants, employees, and business
            contacts. Only you or an agent you authorize to act on your behalf
            may make a verifiable consumer request related to your Personal
            Data.
          </p></ul>


<h3>Virginia Privacy Rights</h3>
<p>
   If you are a Virginia resident, the Virginia Consumer Data Protection
          Act (VCDPA) provides you with certain additional privacy rights
          related to the Personal Data TKC collects about you. Please see below
          to learn more about your rights under the VCDPA.
</p>
<ul>
          <li>
            <strong>Request to Access</strong>
          </li>
          <p>
            You have the right to confirm whether or not TKC is processing your
            Personal Data. You also have the right to access your Personal Data
            processed by TKC. You may request no more than twice annually, free
            of charge, that we provide easy, portable access to all Personal
            Data held by TKC, subject to verification of your identity and
            exceptions provided by law.
          </p>
          <li>
            <strong>Request to Correct</strong>
          </li>
          <p>
            You may request that we correct inaccurate Personal Data we have
            collected from you, subject to verification of your identity and
            exceptions provided by law.
          </p>
          <li>
            <strong>Request to Delete</strong>
          </li>
          <p>
            You may request that we delete Personal Information we have
            collected from you, subject to verification of your identity. Please
            note, that some information may not be eligible for deletion based
            upon applicable law or requirements of customer contracts.
          </p>
          <li>
            <strong>
              Request Not to Process Personal Data for Targeted Advertising
            </strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data
            processed for the purposes of Targeted Advertising. However, TKC
            does not utilize Personal Data for the purposes of Targeted
            Advertising.
          </p>
          <li>
            <strong>Request Not to Sell Personal Data</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data sold to
            third parties. However, TKC does not sell Personal Data, including
            the Personal Data of children under 13 years of age.
          </p>
          <li>
            <strong>Request Not to Profile based on Personal Data</strong>
          </li>
          <p>
            You have the right to opt-out from having your Personal Data used
            for automated processing to evaluate, analyze, or predict personal
            aspects related to your identified or identifiable economic
            situation, health, personal preferences, interests, reliability,
            behavior, location, or movements. However, TKC does not utilize
            Personal Data for the purposes of Profiling.
          </p>
          <li>
            <strong>Exercising Your VCDPA Rights</strong>
          </li>
          <p>
            If you are a Virginia resident and would like to submit a VCDPA
            request, you may:
          </p>
          <ol>
            <li> Contact us by phone at 1-844-475-7190, or</li>
            <li>
              
              Initiate a request by completing our online form which can be
              located here
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Exercise Your Rights</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Powered by</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
  <p>
            Please note that these rights apply only to select Virginia
            consumers and currently exclude job applicants, employees, and
            business contacts. Only you may make a verifiable consumer request
            related to your Personal Data. If your request is denied, you will
            be provided with a method to appeal this finding.
          </p></ul>

<h3>What Are My Non-Discrimination Rights?</h3>
<p>
          We will not discriminate against you for exercising any of your CCPA,
          CPA, CTDPA, UCPA, or VCDPA rights, which means we will not:
        </p>
        <ul>
          <li>Deny you goods or services.</li>
          <li>
            Charge you different prices or rates for goods or services,
            including through granting discounts or other benefits, or imposing
            penalties.
          </li>
          <li>
            Provide you a different level or quality of goods or services.
          </li>
          <li>
            Suggest that you may receive a different price or rate for goods or
            services or a different level or quality of goods or services.
          </li>
        </ul>

<h3>How Will You Verify My Identity If I Make a Request?</h3>
 <p>
          The verifiable consumer request must:
        </p>
        <ul>
          <li>Include your full legal name, email, and billing address.</li>
          <li>
            Describe your request with sufficient detail that allows us to
            properly understand, evaluate, and respond to it.
          </li>
          <li>
            If you are making the request as an authorized agent you must also
            provide; the full legal name of the party for which you are making
            the request and documentation for which your authorization is based.
          </li>
          <p>
            We will use this information to verify your identity using
            reasonable methods in order to process your rights request. These
            methods may include matching information you provided to us with
            information already maintained by us or through the use of a third
            party identify verification service. Depending on the nature of the
            request, we may require additional verification actions be taken,
            including but not limited to providing a signed declaration under
            penalty of perjury that you are the consumer whose Personal
            Information or Data is the subject of the request.
          </p>
          <p>
            We will use the information you provide to verify your identity and
            to respond to your rights request and for no other purpose.
          </p>
          <p>
            We cannot respond to your request or provide you with Personal
            Information or Data if we are not able to verify your identity or
            authority to make the request or confirm the Personal Information or
            Data relates to you.
          </p>
          <p>
            You are not required to have an account with us to make a verifiable
            request.
          </p>
        </ul>
<h3>Children’s Privacy</h3>
<p>
          This website is not directed to, nor do we knowingly collect Personal
          Information and Data from, children under the age of 13. Children
          wishing to make purchases through our services must do so with the
          involvement of a parent or guardian.
        </p>
<h3>Changes to the Policy</h3>
<p>
          We may update the Privacy Policy as needed to reflect changes to our
          business and services. We will post changes to the Privacy Policy on
          our website, with the effective date of the revisions prominently
          noted next to the “Last Modified and Effective” date. We ask that you
          review the Privacy Policy frequently to see changes made to the
          policy. If we make a material change to the Privacy Policy, we will
          provide appropriate notice (like adding a statement to our homepage or
          sending you a notification through email).
        </p>
<h3>How to Update Your Information and Manage Communications</h3>
<p>
          If you want to modify your registration information, please login to
          your account and make the necessary changes. At the time of
          registration, you may be given a choice whether you want to receive
          information about new features, offers or other notices related to TKC
          and its services. When you register, you may opt to not receive these
          communications by not clicking a box that allows us to send you such
          information. You also have the option to opt out at a later date by
          following the instructions in the communication that you receive from
          us.
        </p>
        <p>
          If you are not a California or Virginia resident and you wish to:
        </p>
        <ul>
          <li>Determine what, if any, data we have of yours;</li>
          <li>Receive a copy of any data we possess of yours; or</li>
          <li>
            Have any data that we have of yours erased, corrected, or amended.
          </li>
        </ul>
        <p>
          We can be reached via email <a class="ot-btn-anchor" href="mailto:privacy@tkcholdings.com" target="_blank">at this link</a> for such
  requests. Your request must adequately identify you with your full
  legal name, email, and billing address. Your request must be described with sufficient detail that it allows us to
  properly understand, evaluate, and respond to it.</p>

<h3>Contact for More Information</h3>
<p>
  We welcome your questions and comments regarding our Privacy Policy. Please direct communications to TKC via email
  <a class="ot-btn-anchor" href="mailto:privacy@tkcholdings.com" target="_blank">here</a>.
</p>

<h3><u>California Employee Privacy Notice</u></h3>
<ul>
          <p>
            <strong>
              <u>What is the purpose of this notice?</u>
            </strong>
          </p>
          <p>
            This California Employee Privacy Notice (the “Notice”) describes
            TKC’s collection of Personal Information and Sensitive Personal
            Information from job applicants, employees, and contractors, the
            business purposes for which this data will be used, and the privacy
            rights of California applicants, employees, contractors,
            beneficiaries, emergency contacts, and members of the board of
            directors. This Notice supplements any other privacy notices and is
            not intended to override them. This includes but is not limited to
            any provisions in the Employee Handbook.
          </p>
          <p>
            Job Applicant: an individual seeking employment with TKC through
            creation of an online profile and submission of a complete job
            application through the TKC Career Site at <a class="ot-btn-anchor" href="https://careers.tkcholdings.com/why-us"
          target="_blank">https://careers.tkcholdings.com/why-us</a>. </p>
   <p>
            Employee: any individual hired for a wage, salary, fee, or payment
            paid by TKC to work under the supervision and control of TKC.
          </p>
          <p>
            Contractor: any individual compensated for performing a specified
            job or service under a contract with TKC. Individuals placed by a
            third-party staffing agency to perform temporary work for the
            benefit of TKC but who are compensated by that third-party staffing
            agency are neither employees nor contractors for TKC; such
            individuals are employed by the third-party staffing agency, not
            TKC.
          </p>

          <p>
            <strong>
              <u>Categories of Personal Information Collected</u>
            </strong>
          </p>
          <p>
            TKC collects Personal Information and Sensitive Personal Information
            about you during the application process and throughout the scope of
            your employment with TKC.
          </p>
          <p>
            The categories of Personal Information and Sensitive Personal
            Information collected may include the following:
          </p>
          <ul>
            <li>
              <strong>Identifiers</strong>, such as name, alias, postal address,
              unique personal identifier, online identifier, Internet Protocol
              (IP) address, email address, account name, social security number,
              driver’s license number, passport number, or other similar
              identifiers;
            </li>
            <li>
              <strong>
                Characteristics of protected classifications under California or
                federal law,
              </strong>
              including age or date of birth, national origin, disability,
              citizenship, military status;
            </li>
            <li>
              <strong>Biometric information,</strong> including hair color, eye
              color, fingerprints, height, retina scans, facial recognition,
              voice, and other biometric data;
            </li>
            <li>
              <strong>
                Internet or other electronic network activity information,
              </strong>
              including browsing history, search history, and information
              regarding a consumer’s interaction with an Internet website,
              application, or advertisement;
            </li>
            <li>
              <strong>Geolocation data</strong>, which includes any kind of data
              that allows for determining, with reasonable precision, your
              location;
            </li>
            <li>
              <strong>Professional or employment-related information;</strong>
            </li>
            <li>
              <strong>Education information;</strong>
            </li>
            <li>
              <strong>
                Inferences drawn from any of the information identified in this
                subdivision to create a profile about a consumer reflecting the
                consumer’s preferences, characteristics, psychological trends,
                predispositions, behavior, attitudes, intelligence, abilities,
                and aptitudes;
              </strong>
            </li>
            <li>
              <strong>
                Personal information that reveals your social security, driver’s
                license, state identification card, or passport number;
              </strong>
            </li>
            <li>
              <strong>
                Personal information collected and analyzed concerning a
                consumer’s health.
              </strong>
            </li>
          </ul>
    <p>
            TKC does not use or disclose sensitive personal information for
            purposes other than those specified in section 7027(m) of the CCPA
            regulations.
          </p>

          <p>
            <strong>
              <u>Business Purpose</u>
            </strong>
          </p>
          <p>
            TKC uses Personal Information and Sensitive Personal Information,
            for all purposes related to the application for employment, and the
            creation, administration, and termination of your employment
            relationship with the TKC and for all purposes related to clients.
            These purposes include, but are not limited to, the following:
          </p>
          <ul>
            <li>Making a decision about your recruitment or appointment.</li>
            <li>
              To assess your skills, qualifications, and suitability for the
              work or role for which you are applying.
            </li>
            <li>
              To carry out background and reference checks, where applicable.
            </li>
            <li>To communicate with you about the recruitment process.</li>
            <li>Determining the terms on which you work for us.</li>
            <li>
              Confirming you are legally entitled to work in the United States.
            </li>
            <li>
              To administer compensation, including, but not limited to, payment
              of wages and bonuses and income tax withholding and reimbursement
              of business expenses.
            </li>
            <li>
              Providing employment benefits to you if applicable, for example,
              medical insurance, life insurance, and retirement savings plans.
            </li>
            <li>
              Business management and planning, including accounting and
              auditing.
            </li>
            <li>
              Conducting performance reviews, managing performance and
              determining performance requirements.
            </li>
            <li>Making decisions about salary reviews and compensation.</li>
            <li>
              Assessing qualifications for a particular job or task, including
              decisions about promotions.
            </li>
            <li>
              Gathering evidence for possible grievance or disciplinary
              hearings.
            </li>
            <li>
              Making decisions about your continued employment or engagement.
            </li>
            <li>
              Making arrangements for the termination of our working
              relationship.
            </li>
            <li>Education, training and development requirements.</li>
            <li>
              Dealing with legal disputes involving you, or other employees,
              workers and contractors, including accidents at work.
            </li>
            <li>Ascertaining your fitness to work.</li>
            <li>
              To administer leaves of absence as required by law or company
              policy.
            </li>
            <li>Complying with health and safety obligations.</li>
            <li>To prevent fraud.</li>
            <li>
              To monitor your use of our information and communication systems
              to ensure compliance with our policies.
            </li>
            <li>
              To ensure network and information security, including preventing
              unauthorized access to our computer and electronic communications
              systems and preventing malicious software distribution.
            </li>
            <li>
              To conduct data analytics studies to review and better understand
              employee retention and attrition rates.
            </li>
            <li>Equal opportunities monitoring.</li>
            <li>
              To exercise the TKC’s rights under applicable law and to support
              any claim, defense, or declaration in a case or before a
              jurisdictional and/or administrative authority, arbitration, or
              mediation panel.
            </li>
            <li>
              To meet legal and regulatory requirements including civil
              discovery in litigation involving the TKC or affiliated companies.
            </li>
            <li>
              To facilitate administrative functions, including, but not limited
              to, the management and operation of information technology and
              communications systems, risk management and insurance functions,
              budgeting, financial management and reporting, strategic planning,
              and the maintenance of licenses, permits and authorizations
              applicable to the TKC’s business operations.
            </li>
          </ul>

          <p>
            <strong>
              <u>
                Retention of Personal Information and Sensitive Personal
                Information
              </u>
            </strong>
          </p>
          <p>
            Personal information and Sensitive Personal Information will not be
            kept for longer than is necessary for the Business Purpose for which
            it is collected and processed and will be retained in accordance
            with our internal document retention policies. In certain cases,
            laws or regulations require us to keep records for specific periods
            of time, including following termination of the employment
            relationship. In other cases, records are retained in order to
            administer the employment relationship or to resolve queries or
            disputes which arise from time to time.
          </p>

          <p>
            <strong>
              <u>Privacy Rights</u>
            </strong>
          </p>
          <p>
            The California Consumer Privacy Act (CCPA) provides you with certain
            additional privacy rights related to the Personal Information and
            Sensitive Personal Information TKC collects about you. Please see
            below to learn more about your rights under the CCPA.
          </p>
          <ul>
            <li>
              <strong>Request to Know</strong>
            </li>
            <p>
              You may request no more than twice in any twelve (12) month period
              and, subject to verification of your identity and certain
              exemptions, we will provide:
            </p>
            <ol>
              <li>
                The categories of Personal Information we collected about you.
              </li>
              <li>
                The categories of sources from which the Personal Information is
                collected.
              </li>
              <li>
                The categories of Personal Information sold or shared for
                purposes of cross-contextual advertising to a third party, as
                well as the categories of third parties to whom such personal
                information was disclosed, by category of categories of personal
                information for each category of third party.
              </li>
              <li>
                The categories of Personal Information that the business
                disclosed about the consumer for a business purpose and the
                categories of persons to whom it was disclosed for a business
                purpose.
              </li>
              <li>
                Our business or commercial purpose for collecting, selling, or
                sharing for purposes of cross-contextual advertising your
                Personal Information.
              </li>
              <li>
                The specific pieces of Personal Information we collected about
                you.
              </li>
            </ol>
            <li>
              <strong>Request to Delete</strong>
            </li>
            <p>
              You may request that we delete Personal Information we have
              collected from you, subject to verification of your identity.
              Please note, that some information may not be eligible for
              deletion based upon applicable law or requirements of contracts.
            </p>

            <li>
              <strong>Request to Correct</strong>
            </li>
            <p>
              You may request that we correct inaccurate Personal Information
              and Sensitive Personal Information we have collected from you,
              subject to verification of your identity and exceptions provided
              by law.
            </p>

            <li>
              <strong>
                Request Not to Sell or Share Personal Information and Sensitive
                Personal Information
              </strong>
            </li>
            <p>
              You have the right to opt-out from having your Personal
              Information and Sensitive Personal Information sold to third
              parties for purposes of cross-contextual advertising. However, TKC
              does not sell Personal Information or Sensitive Information nor
              does TKC share Personal Information or Sensitive Personal
              Information with third parties for purposes of cross-contextual
              advertising; including TKC has no actual knowledge of any sales of
              Personal Information or Sensitive Personal Information of minors
              under 16 years of age.
            </p>

            <li>
              <strong>Request to Limit Use and Disclosure</strong>
            </li>
            <p>
              You may request that we limit the use and disclosure of your
              Sensitive Personal Information.
            </p>
          </ul>
          <p>
            <strong>Exercising Your CCPA Rights</strong>
          </p>
          <p>
            If you are a California resident and would like to submit a CCPA
            request, you or your authorized agent may:
          </p>
          <ul>
            <ol>
              <li> Contact us by phone at 1-844-475-7190, or</li>
              <li>
                
                Initiate a request by completing our online form which can be
                located here
              </li>
            </ol>
      <a class="ot-btn-anchor"
          href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
          <button type="button" class="ot-exercise-button ot-exercise-button-light">
              <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
              <span class="ot-text-container">Exercise Your Rights</br>
                  <span class="ot-subtext">
                      <span class="ot-powered-by-text">Powered by</span>
                      <span class="onetrust-text">OneTrust</span>
                  </span>
              </span>
          </button>
      </a>
  </ul>
 <p>
            <strong>
              <u>What Are My CCPA Non-Discrimination Rights?</u>
            </strong>
          </p>
          <p>
            We will not discriminate and/or retaliate against you for exercising
            any of your CCPA rights to receive a notice at the time of
            collection of your Personal Information or Sensitive Personal
            Information, or upon filing a private right to action following a
            data breach involving your Personal Information and/or Sensitive
            Personal Information caused by a failure of TKC to maintain
            reasonable safeguards.
          </p>

          <p>
            <strong>
              <u>How Will You Verify My Identity If I Make a Request?</u>
            </strong>
          </p>
          <p>The verifiable request must: </p>
          <ul>
            <li>Include your full legal name, email, and billing address.</li>
            <li>
              Describe your request with sufficient detail that allows us to
              properly understand, evaluate, and respond to it.
            </li>
            <li>
              If you are making the request as an authorized agent you must also
              provide; the full legal name of the party for which you are making
              the request and documentation for which your authorization is
              based.
            </li>
          </ul>

          <p>
            We will use this information to verify your identity using
            reasonable methods in order to process your rights request. These
            methods may include matching information you provided to us with
            information already maintained by us or through the use of a
            third-party identity verification service. Depending on the nature
            of the request, we may require additional verification actions be
            taken, including but not limited to providing a signed declaration
            under penalty of perjury that you are the consumer whose Personal
            Information or Sensitive Personal Information is the subject of the
            request.
          </p>
          <p>
            We will use the information you provide to verify your identity and
            to respond to your rights request and for no other purpose.
          </p>
          <p>
            We cannot respond to your request or provide you with Personal
            Information or Sensitive Personal Information if we are not able to
            verify your identity or authority to make the request or confirm the
            Personal Information or Sensitive Personal Information relates to
            you.
          </p>
          <p>
            You are not required to have an account with us to make a verifiable
            request.
          </p>

          <p>
            <strong>
              <u>Questions</u>
            </strong>
          </p>
          <p>
            If you have any questions or concerns about this Notice, please <a class="ot-btn-anchor" href="mailto:privacy@tkcholdings.com"
          target="_blank">click here to send an email</a>.</p>

</ul>`,
};

export const PrivacyPolicyDialogSpanish: DialogChildren = {
  open: true,
  title: "POLÍTICA DE PRIVACIDAD",
  subtitle: "",
  replaceId: "replaceId",
  affirmativeButton: { color: "primary", caption: "Close" },
  content: `

  <h1>POLÍTICA DE PRIVACIDAD</h1>

  <div id="replaceId">
    <h2>Fecha de entrada en vigencia: 31 de diciembre de 202 </h2>
  </div>
  <hr>
</div>
<p>Esta Política de privacidad explica y rige la manera en que TKC
        Holdings, Inc. y sus subsidiarias (denominadas colectivamente en este
        documento “TKC”) recopilan, utilizan, mantienen y divulgan información
        relacionada con su uso de nuestros servicios. Al utilizar nuestros
        servicios, usted acepta las políticas y prácticas descritas en esta
        Política de privacidad. Esta Política de privacidad puede cambiar cada
        cierto tiempo. Cuando se realicen cambios, actualizaremos la fecha de
        "Última modificación y fecha de entrada en vigencia" en la parte
        superior de esta Política de privacidad y, en algunos casos, podremos
        proporcionar un aviso adicional como se describe a continuación. El uso
        continuado de nuestros servicios después de que realizamos cambios se
        considera la aceptación de dichos cambios, así que consulte la Política
        de privacidad para obtener actualizaciones. Si no acepta estas políticas
        y prácticas, no utilice el sitio web ni los servicios.</p>

<h2>Esta Política describe:</h2>
<ul>
  <li>información y datos personales que recopilamos </li>
  <li>cómo recopilamos su información y datos personales</li>
  <li>cómo utilizamos su información y datos personales</li>
  <li>cómo compartimos su información y datos personales con terceros</li>
  <li>cómo protegemos su información y datos</li>
  <li>derechos de privacidad de California</li>
  <li>derechos de privacidad de Colorado</li>
  <li>derechos de privacidad de Connecticut</li>
  <li>derechos de privacidad de Utah</li>
          <li>derechos de privacidad de Virginia</li>
          <li>derechos a la no discriminación</li>
          <li>verificación de identificación</li>
          <li>privacidad de los niños</li>
          <li>cambios a la Política </li>
          <li>cómo actualizar su información y gestionar las comunicaciones</li>
          <li>contacto para obtener más información</li>
          <li>aviso de privacidad para empleados de California</li> 
</ul>

<h2>Información y datos personales que recopilamos</h2>
<p>
          Los “Datos personales” hacen referencia a cualquier información que
          esté vinculada o razonablemente vinculable a una persona física
          identificada o identificable. Los "datos personales" no incluyen datos
          anonimizados ni información disponible públicamente.
        </p>
        <p>
          Los "Datos confidenciales" se refieren a una categoría de datos
          personales que incluye: 1. Datos personales que revelen origen racial
          o étnico, creencias religiosas, diagnóstico de salud física o mental,
          orientación sexual o condición de ciudadanía o inmigración. 2. El
          tratamiento de datos genéticos o biométricos con el fin de identificar
          de forma única a una persona física. 3. Los datos personales
          recopilados de un niño conocido. o 4. Datos precisos de
          geolocalización.
        </p>
        <p>
          “Información personal” significa cualquier información que
          identifique, se relacione, describa, sea razonablemente capaz de
          asociarse o podría razonablemente vincularse, directa o
          indirectamente, a cualquier persona individual u hogar. No incluye
          datos anónimos o agregados que no puedan asociarse con una persona
          individual o un hogar.
        </p>
        <p>
          “Información personal confidencial” significa información personal que
          revela el número de seguro social, licencia de conducir, tarjeta de
          identificación estatal o pasaporte de un consumidor. El inicio de
          sesión de la cuenta de un consumidor, la cuenta financiera, la tarjeta
          de débito o el número de tarjeta de crédito en combinación con
          cualquier código de seguridad o acceso, contraseña o credencial
          requeridos que permitan el acceso a una cuenta. La geolocalización
          precisa de un consumidor; el origen racial o étnico, las creencias
          religiosas o filosóficas o la afiliación sindical de un consumidor. El
          contenido del correo postal, correo electrónico y mensajes de texto de
          un consumidor, a menos que la empresa sea el destinatario previsto de
          la comunicación. Los datos genéticos de un consumidor. El
          procesamiento de información biométrica con el fin de identificar de
          forma única a un consumidor. Información personal recopilada y
          analizada sobre la salud del consumidor. Información personal
          recopilada y analizada sobre la vida sexual u orientación sexual de un
          consumidor. La información personal confidencial que esté “disponible
          públicamente” no se considerará Información personal confidencial o
          Información personal.
        </p>
        <p>
          Podemos recopilar, usar, almacenar y transferir diferentes tipos de
          Información y datos personales, e Información y datos personales
          confidenciales sobre usted. Las categorías de información y datos
          recopilados pueden incluir lo siguiente (muchas de estas categorías
          solo se recopilan para personas empleadas por TKC Holdings, Inc. o sus
          subsidiarias):
        </p>
  <ul>
          <li>
            
            <strong>Identificadores</strong>, como nombre, alias, dirección
            postal, identificador personal único, identificador en línea,
            dirección de protocolo de Internet (IP), dirección de correo
            electrónico, nombre de cuenta, número de Seguro Social, número de
            licencia de conducir, número de pasaporte u otros identificadores
            similares.
          </li>
          <li>
            
            <strong>
              • Características de las clasificaciones protegidas según la ley
              federal o de California,
            </strong>
             incluida la edad o fecha de nacimiento, origen nacional,
            discapacidad, ciudadanía, estado militar.
          </li>
          <li>
            
            <strong>Información biométrica</strong>, incluido el color de
            cabello, color de ojos, huellas dactilares, altura, exploración de
            retina, reconocimiento facial, voz y otros datos biométricos.
          </li>
          <li>
            
            <strong>
              • Información sobre la actividad de Internet u otras redes
              electrónicas,
            </strong>
            incluido el historial de navegación, el historial de búsqueda y la
            información sobre la interacción de un consumidor con un sitio web,
            una aplicación o un anuncio de Internet.
          </li>
          <li>
            
            <strong>Datos de geolocalización</strong>, que incluyen cualquier
            tipo de dato que permita determinar, con precisión razonable, su
            ubicación.
          </li>
          <li>
            
            <strong>
              Información profesional o relacionada con el empleo.
            </strong>
          </li>
          <li>
            
            <strong>Información sobre educación.</strong>
          </li>
          <li>
            
            <strong>
              Inferencias extraídas de cualquiera de la información identificada
              en esta subdivisión para crear un perfil sobre un consumidor que
              refleje las preferencias, características, tendencias
              psicológicas, predisposiciones, comportamiento, actitudes,
              inteligencia, habilidades y aptitudes del consumidor.
            </strong>
          </li>
          <li>
            
            <strong>
              Información personal que revele su número de seguro social,
              licencia de conducir, tarjeta de identificación estatal o
              pasaporte.
            </strong>
          </li>
          <li>
            
            <strong>
              Información personal recopilada y analizada sobre la salud del
              consumidor.
            </strong>
          </li>
        </ul>

<h3>Cómo recopilamos su Información y datos personales</h3>

<p> Podemos recopilar Información y datos personales desde una variedad de
          fuentes y métodos. Esto incluye:</p>
<ul>
          <li>
            <strong>
              Información que usted proporciona de forma voluntaria
            </strong>
          </li>

          <p>
            Puede brindarnos su Información y datos personales completando
            formularios o comunicándose con nosotros por correo postal,
            teléfono, correo electrónico o de otro modo. Esto incluye
            Información y datos personales que usted proporciona cuando:
          </p>
          <ol>
            <li>
              Envía un formulario de Solicitud para obtener más información o
              Contáctenos en nuestro sitio web.
            </li>
            <li>Envía un mensaje a través de nuestro sitio web.</li>
            <li>Envía fondos o realiza pagos a través de nuestro servicio. </li>
            <li>Envía correos electrónicos a través de nuestro servicio. </li>
            <li>
              Llama, envía un correo electrónico, envía un fax, envía un mensaje
              de texto, chatea o escribe.
            </li>
            <li>Crea una cuenta.</li>
            <li>Adquirió servicios.</li>
            <li>Solicita productos.</li>
          </ol>

          <li>
            <strong>
              Información que recopilamos cuando utiliza nuestros servicios
            </strong>
          </li>

          <p>
            <u>Información recopilada de forma automática</u>
          </p>
          <p>
            Cuando visita nuestro sitio web, nuestro servidor web recoge
            automáticamente su dirección de protocolo de Internet (IP), que es
            el número asignado a su computadora cuando se conecta a Internet.
            Nuestro servidor web también puede identificar elementos como el
            tipo de navegador web, el sistema operativo que utiliza, el
            proveedor de servicios de Internet (ISP), las páginas de
            referencia/salida, el sistema operativo, la marca de fecha/hora o
            los datos de secuencia de clics. Cuando accede y utiliza nuestros
            servicios desde sus dispositivos móviles, recibimos datos de ese
            dispositivo móvil. Esto puede incluir sus datos de ubicación,
            dirección IP y tipo de dispositivo. Podemos utilizar las direcciones
            IP para identificar a un usuario cuando sea necesario para
            garantizar el cumplimiento de los Términos y condiciones del sitio
            web.
          </p>

          <p>
            <u>Uso de cookies</u>
          </p>
          <p>
            Las cookies son pequeños archivos que nosotros o nuestro proveedor
            de servicios transferimos al disco duro de su computadora a través
            de su navegador web que nos permite a nosotros o a los sistemas de
            nuestro proveedor de servicios reconocer su navegador y capturar y
            recordar cierta información. Utilizamos las cookies para analizar el
            movimiento en el sitio web, como el total de visitantes al sitio web
            y las páginas visitadas, tomar huellas digitales, la seguridad del
            sitio y para implementar mejoras en el sitio web. Por otra parte,
            los socios de nuestro sitio web también pueden utilizar las cookies
            al conectarse con los servicios y los sitios web cuyo acceso enlace
            a nuestro sitio web. La mayoría de los navegadores web están
            inicialmente configurados para recibir cookies. Si no desea recibir
            cookies, los navegadores suelen tener la función "Ayuda" o
            "Herramientas de Internet" que le mostrará cómo evitar que su
            navegador acepte nuevas cookies y cómo borrarlas de su computadora.
            Si rechaza las cookies, podrá seguir utilizando nuestro sitio web,
            pero su capacidad para utilizar algunas funciones o áreas de nuestro
            sitio web puede ser limitada. Para obtener más información sobre las
            cookies, visite
            <a class="ot-btn-anchor" href="http://www.allaboutcookies.org"
          target="blank">www.allaboutcookies.org</a>
            .
          </p>
          <p>
            Utilizamos herramientas de terceros incluidas, entre otras,
            herramientas de protección proporcionadas por Google y CloudFlare
            para ayudarnos a comprender mejor a los visitantes de nuestro sitio
            web. Estas herramientas recopilan datos de uso y dirección IP, como
            el tiempo que un usuario pasa en una página, las páginas que visita
            y los sitios web que visita antes y después de visitar nuestro sitio
            web. Con base en esta información, estos proveedores recopilan datos
            agregados sobre el tráfico y las interacciones del sitio web, que
            utilizamos para ofrecer mejores experiencias de usuario y
            herramientas en el futuro. Para obtener más información, visite los
            Términos y Privacidad de Google o CloudFlare.
          </p>
          <li>
            <strong>Información que recopilamos de terceros</strong>
          </li>
          <p>
            Podemos recopilar Información y datos personales desde otras
            fuentes, incluidas nuestras asociaciones de confianza con
            proveedores de servicios. La recopilación, uso y divulgación de
            Información y datos personales recibidos de terceros se rigen por
            las políticas de privacidad indicadas en el sitio web donde el
            usuario envió la información. Los terceros pueden enviarle sus
            propias cookies y etiquetas de píxeles, y pueden recopilar
            información y utilizarla de forma incompatible con esta Política.
            Revise detenidamente estas políticas de privacidad de terceros para
            comprender cómo estos terceros pueden recopilar, utilizar y divulgar
            su información.
          </p>
        </ul>

<h3> Cómo utilizamos su Información y datos personales</h3>
 <p>
          TKC utiliza la información que recopilamos sobre usted o que usted nos
          proporciona, incluida la Información y datos personales, para los
          siguientes fines comerciales:
        </p>
        <ul>
          <li>
            Para proporcionarle nuestros productos y servicios, y para operar
            nuestro negocio.
          </li>
          <li>
            Para comunicarnos con usted y responder preguntas específicas
            relacionadas con los productos y servicios ofrecidos.
          </li>
          <li>
            Para obtener más información sobre cómo los visitantes utilizan el
            sitio web (análisis de datos) y medir áreas de interés con el fin de
            mejorar el sitio web, los productos y los servicios.
          </li>
          <li>
            Para nuestros fines de marketing interno, que incluyen, entre otros,
            enviarle material sobre productos, servicios, actualizaciones, etc.
            que creemos que pueden ser de su interés.
          </li>
          <li>
            Para mejorar la seguridad del sitio web, prevenir actividades
            potencialmente fraudulentas, prohibidas o ilegales, y hacer cumplir
            nuestros Términos y condiciones.
          </li>
          <li>Para resolver litigios y ejercer la resolución de problemas. </li>
          <li>
            Para responder a solicitudes de entidades gubernamentales, en
            relación con una investigación de actividad ilegal real o presunta,
            y otras funciones requeridas por la ley.
          </li>
          <li>
            Para cualquier otro propósito divulgado en el momento en que
            proporciona su información o según lo establecido en esta Política.
          </li>
        </ul>
        <p>
          TKC no utiliza ni divulga información personal confidencial para fines
          distintos de los especificados en la sección 7027(m) de las
          regulaciones de la Ley de Privacidad del Consumidor de California
          (“CCPA”).
        </p>

<h3>Cómo compartimos su Información y datos personales con terceros</h3>
 <p>
          Compartimos información relacionada con su cuenta y sus compras en las
          siguientes circunstancias:
        </p>
        <ul>
          <li>
            <strong>Proveedores de servicio</strong>. Contratamos a terceros
            para proporcionar servicios que nos permitan operar nuestro negocio.
            Su Información y datos personales pueden ser divulgados a estos
            proveedores de servicios externos para que podamos brindarle
            nuestros servicios y productos. Los servicios de terceros incluyen,
            entre otros, (1) respaldar el uso de nuestro sitio web, (2) brindar
            soporte operativo, de marketing o publicidad, y (3) otros fines para
            respaldar nuestro negocio, como el análisis de datos. Los
            proveedores de servicios pueden utilizar su información únicamente
            en nuestro nombre según lo especificado en el contrato del
            proveedor.
          </li>
          <li>
            <strong>Para fines de seguridad</strong>. Para algunos de nuestros
            productos, para que nuestros servicios se realicen, debemos divulgar
            información personal limitada que usted nos haya proporcionado a un
            centro penitenciario, quien debe revisar esta información por
            motivos de seguridad. Además, es posible que se le solicite al
            destinatario final de los servicios o productos que compre recibir
            información personal limitada para que pueda dar su consentimiento
            para recibir los servicios o productos en cuestión.
          </li>
          <li>
            <strong>Proceso legal</strong>. Sin perjuicio de la ley aplicable,
            podemos revelar información sobre usted (i) si así lo exige la ley,
            un reglamento o un proceso legal, como una citación; (ii) en
            respuesta a solicitudes de entidades gubernamentales, como
            autoridades encargadas de hacer cumplir la ley; (iii) cuando creemos
            que la divulgación es necesaria o apropiada para evitar daños,
            lesiones o pérdidas físicas, económicas o de otro tipo; o (iv) en
            relación con una investigación de actividad ilegal real o presunta.
          </li>
          <li>
            <strong>Terceros internos</strong>. Podemos compartir información y
            datos personales con nuestra empresa matriz TKC Holdings, Inc. y
            otras empresas propiedad o controladas por TKC Holdings, Inc.,
            quienes pueden utilizar la Información y los datos personales para
            los fines descritos en este documento.
          </li>
          <li>
            <strong>Transacciones comerciales</strong>. Terceros a quienes
            podemos optar por vender, transferir o fusionar partes de nuestro
            negocio o nuestros activos. De forma alternativa, podemos intentar
            adquirir otros negocios o fusionarnos con ellos. Si se produce un
            cambio en nuestro negocio, los nuevos propietarios podrán utilizar
            su Información y datos personales de la misma manera que se
            establece en esta Política de privacidad.
          </li>
          <li>
            <strong>Seguridad del sitio web</strong>. Utilizamos productos de
            Google y CloudFlare para proteger nuestro sitio web de varios tipos
            de intentos de procesamiento abusivo. Para que estas herramientas
            funcionen, analizan diversos datos que recopilan de cada visitante,
            que puede incluir la dirección IP, los movimientos del mouse, la
            duración de la visita y otros datos. Estos datos se envían a Google
            o CloudFlare para determinar si el visitante es una persona física o
            un programa automatizado abusivo (<i>p. ej.</i>, un bot). Para
            obtener más información, visite los Términos y Privacidad de Google
            o CloudFlare.
          </li>
        </ul>
<h3>Cómo protegemos su información</h3>
<p>
          Nos esforzamos por incorporar medidas de seguridad y métodos de
          políticas físicas, técnicas y administrativas para proteger su
          información de identificación personal. También es importante tomar
          medidas para mantener la confidencialidad de su información de cuenta
          y un acceso seguro desde su computadora. Siempre asegúrese de cerrar
          la sesión de su cuenta al utilizar una computadora compartida o
          pública. Tenga en cuenta que no se puede garantizar que ninguna
          transmisión de datos a través de Internet, redes móviles, transmisión
          inalámbrica o almacenamiento electrónico de información sea 100 %
          segura. Por tanto, no podemos garantizar su absoluta seguridad. Es
          posible que terceros intercepten o accedan a transmisiones o
          comunicaciones privadas de forma ilegal. Cualquier tipo de transmisión
          se realiza bajo su propio riesgo.
        </p>
<h3>Derechos de privacidad de California</h3>
<p>
          Si es residente de California, la Ley de Privacidad del Consumidor de
          California (CCPA) le otorga ciertos derechos de privacidad adicionales
          relacionados con la información personal que TKC recopila o ha
          recopilado sobre usted. Consulte a continuación para obtener más
          información sobre sus derechos según la CCPA.
        </p>
        <ul>
          <li>
            <strong>Solicitud de información</strong>
          </li>
          <p>
            No puede solicitar información más de dos veces en cualquier período
            de 12 meses y, sujeto a la verificación de su identidad y ciertas
            exenciones, le proporcionaremos:
          </p>
          <ol>
            <li>
              
              Las categorías de Información personal que recopilamos sobre
              usted.
            </li>
            <li>
              
              Las categorías de fuentes de las que se recopila la Información
              personal.
            </li>
            <li>
              
              Las categorías de Información personal vendida o compartida con
              fines de publicidad multicontextual a un tercero, así como las
              categorías de terceros a quienes se reveló dicha información
              personal, por categoría de categorías de información personal para
              cada categoría de tercero.
            </li>
            <li>
              
              Las categorías de Información personal que la empresa reveló sobre
              el consumidor con fines comerciales y las categorías de personas a
              quienes se reveló con fines comerciales.
            </li>
            <li>
              
              Nuestro propósito comercial o de negocios para recopilar, vender o
              compartir su información personal con fines de publicidad
              multicontextual.
            </li>
            <li>
              
              Los datos personales específicos que recopilamos sobre usted.
            </li>
          </ol>
          <li>
            <strong>Solicitud de eliminación</strong>
          </li>
          <p>
            Puede solicitar que eliminemos la Información personal que hemos
            recopilado de usted, sujeto a la verificación de su identidad. Tenga
            en cuenta que es posible que cierta información no sea elegible para
            su eliminación según la ley aplicable o los requisitos de los
            contratos de los clientes.
          </p>
          <li>
            <strong>Solicitud de corrección</strong>
          </li>
          <p>
            Puede solicitar que corrijamos la Información personal inexacta que
            hemos recopilado de usted, sujeto a la verificación de su identidad
            y las excepciones previstas por la ley.
          </p>
          <li>
            <strong>
              Solicitud de no vender ni compartir información personal
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que no se venda su Información personal ni
            su Información personal confidencial a terceros o compartirla con
            terceros con fines de publicidad multicontextual. Sin embargo, TKC
            no vende Información personal o Información confidencial, ni TKC
            comparte Información personal o Información personal confidencial
            con terceros con fines de publicidad multicontextual. TKC no tiene
            conocimiento real de ninguna venta de Información personal o
            Información personal confidencial de menores de 16 años.
          </p>
          <li>
            <strong>Solicitud para limitar el uso y la divulgación</strong>
          </li>
          <p>
            Puede solicitar que limitemos el uso y la divulgación de su
            Información personal confidencial. Sin embargo, TKC no recopila
            Información personal sensible.
          </p>
          <li>
            <strong>Ejercicio de sus derechos de la CCPA</strong>
          </li>
          <p>
            Si es residente de California y desea presentar una solicitud de la
            CCPA, usted o su agente autorizado pueden:
          </p>
          <ol>
            <li>Contactarnos por teléfono al 1-844-475-7190, o</li>
            <li>
              
              Iniciar una solicitud completando nuestro formulario en línea que
              se puede encontrar aquí
            </li>
          </ol>

  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Ejerza sus derechos</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Desarrollado por</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
    <p>
            Tenga en cuenta que estos derechos se aplican a consumidores
            selectos de California. Solo usted, o un agente que usted autorice
            para actuar en su nombre, puede realizar una solicitud de consumidor
            verificable relacionada con su información personal. Para autorizar
            a otra persona a realizar una solicitud verificable en su nombre,
            debe proporcionarle a esa persona un permiso por escrito que
            describa claramente su autoridad para realizar una solicitud en su
            nombre. Ese agente también debe poder verificar su identidad con
            nosotros y brindarnos su autoridad para actuar en su nombre. Una
            persona a quien usted le haya proporcionado un poder notarial de
            conformidad con las Secciones 4000 a 4465 del Código Sucesorio de
            California también puede presentar una solicitud en su nombre. Si se
            rechaza su solicitud, se le proporcionará un método para apelar este
            hallazgo.
          </p>

          <li>
            <strong>Otros derechos de privacidad de California. </strong>
          </li>
          <p>
            <u>La Sección 1798.83 del Código Civil de California </u> permite a
            los residentes de California que nos han proporcionado información
            de identificación personal a nosotros o a nuestros anunciantes
            externos y socios de marketing, si los hubiera, solicitar cierta
            información sobre nuestra divulgación de información de
            identificación personal a terceros con fines de marketing directo.
            No compartimos la información que recopilamos sobre usted con
            terceros para fines de marketing directo de dichos terceros.
          </p>
          <p><u>Configuración "No rastrear" de su navegador</u>. Algunos
            navegadores web incorporan una función "No rastrear" (DNT) que
            indica a los sitios web que visita que no desea que se rastree su
            actividad en línea. Muchos sitios web y aplicaciones, incluido el
            nuestro, actualmente no responden a las señales DNT del navegador
            web porque dichas señales aún no son uniformes. Para obtener más
            información sobre las señales DNT, visite <a class="ot-btn-anchor" href="http://allaboutdnt.com" target="blank">http://allaboutdnt.com</a>.  Otros sitios web de terceros pueden realizar un seguimiento de sus
            actividades de navegación cuando le brindan contenido, lo que les
            permite personalizar lo que le presentan en sus sitios web.</p>
</ul>
<h3>Derechos de privacidad de Colorado</h3>
<p>
          Si es residente de Colorado, la Ley de Privacidad de Colorado (CPA) le
          otorga ciertos derechos de privacidad adicionales relacionados con los
          datos personales que TKC recopila sobre usted. Consulte a continuación
          para obtener más información sobre sus derechos según la CPA.
        </p>
        <ul>
          <li>
            <strong>Solicitud de acceso</strong>
          </li>
          <p>
            Tiene derecho a confirmar si TKC está procesando o no sus Datos
            personales. También tiene derecho a acceder a sus Datos personales
            procesados por TKC. No puede solicitar más de dos veces al año, de
            forma gratuita, que le proporcionemos acceso fácil y portátil a
            todos los Datos personales en poder de TKC, sujeto a la verificación
            de su identidad y a las excepciones previstas por la ley.
          </p>
          <li>
            <strong>Solicitud de corrección</strong>
          </li>
          <p>
            Puede solicitar que corrijamos los Datos personales inexactos que
            hemos recopilado de usted, sujeto a la verificación de su identidad
            y las excepciones previstas por la ley.
          </p>
          <li>
            <strong>Solicitud de eliminación</strong>
          </li>
          <p>
            Puede solicitar que eliminemos la Información personal que hemos
            recopilado de usted, sujeto a la verificación de su identidad. Tenga
            en cuenta que es posible que cierta información no sea elegible para
            su eliminación según la ley aplicable o los requisitos de los
            contratos de los clientes.
          </p>
          <li>
            <strong>
              Solicitud de no procesar Datos personales para publicidad dirigida
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que no se procesen sus datos personales
            con fines de publicidad dirigida. Sin embargo, TKC no utiliza Datos
            personales con fines de publicidad dirigida.
          </p>
          <li>
            <strong>Solicitud de no vender datos personales</strong>
          </li>
          <p>
            Tiene derecho a optar por que no se vendan sus Datos personales a
            terceros. Sin embargo, TKC no vende Datos personales. TKC no tiene
            conocimiento real de ninguna venta de Datos personales de niños
            menores de 13 años.
          </p>
          <li>
            <strong>
              Solicitud de no crear un perfil basado en Datos personales
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que sus Datos personales no se utilicen
            para procesamiento automatizado para evaluar, analizar o predecir
            aspectos personales relacionados con su situación económica, salud,
            preferencias personales, intereses, confiabilidad, comportamiento,
            ubicación o movimientos identificados o identificables. Sin embargo,
            TKC no utiliza Datos personales para fines de elaboración de
            perfiles.
          </p>
          <li>
            <strong>Ejercicio de sus derechos de la CPA</strong>
          </li>
          <p>
            Si es residente de Colorado y desea presentar una solicitud de la
            CPA, usted puede:
          </p>
          <ol>
            <li>Contactarnos por teléfono al 1-844-475-7190, o</li>
            <li>
              
              Iniciar una solicitud completando nuestro formulario en línea que
              se puede encontrar aquí
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Ejerza sus derechos</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Desarrollado por</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
     <p>
            Tenga en cuenta que estos derechos se aplican solo a consumidores
            seleccionados de Colorado y actualmente excluyen a solicitantes de
            empleo, empleados y contactos comerciales. Solo usted podrá realizar
            una solicitud de consumidor verificable relacionada con sus Datos
            personales. Si se rechaza su solicitud, se le proporcionará un
            método para apelar este hallazgo.
          </p>
</ul>
<h3>Derechos de privacidad de Connecticut</h3>
<p>
          Si es residente de Connecticut, la Ley de Privacidad de Datos de
          Connecticut (CTDPA) le otorga ciertos derechos de privacidad
          adicionales relacionados con los datos personales que TKC recopila
          sobre usted. Consulte a continuación para obtener más información
          sobre sus derechos según la CTDPA.
        </p>
        <ul>
          <li>
            <strong>Solicitud de acceso</strong>
          </li>
          <p>
            Tiene derecho a confirmar si TKC está procesando o no sus Datos
            personales. También tiene derecho a acceder a sus Datos personales
            procesados por TKC. No puede solicitar más de una vez al año, de
            forma gratuita, que le proporcionemos acceso fácil y portátil a
            todos los Datos personales en poder de TKC, sujeto a la verificación
            de su identidad y a las excepciones previstas por la ley.
          </p>
          <li>
            <strong>Solicitud de corrección</strong>
          </li>
          <p>
            Puede solicitar que corrijamos los Datos personales inexactos que
            hemos recopilado de usted, sujeto a la verificación de su identidad
            y las excepciones previstas por la ley.
          </p>
          <li>
            <strong>Solicitud de eliminación</strong>
          </li>
          <p>
            Puede solicitar que eliminemos la Información personal que hemos
            recopilado de usted, sujeto a la verificación de su identidad. Tenga
            en cuenta que es posible que cierta información no sea elegible para
            su eliminación según la ley aplicable o los requisitos de los
            contratos de los clientes.
          </p>
          <li>
            <strong>
              Solicitud de no procesar Datos personales para publicidad dirigida
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que no se procesen sus datos personales
            con fines de publicidad dirigida. Sin embargo, TKC no utiliza Datos
            personales con fines de publicidad dirigida, incluidos los Datos
            personales de menores de 18 años.
          </p>
          <li>
            <strong>Solicitud de no vender datos personales</strong>
          </li>
          <p>
            Tiene derecho a optar por que no se vendan sus Datos personales a
            terceros. Sin embargo, TKC no vende Datos personales, incluidos los
            Datos personales de menores de 18 años.
          </p>
          <li>
            <strong>
              Solicitud de no crear un perfil basado en Datos personales
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que sus Datos personales no se utilicen
            para procesamiento automatizado para evaluar, analizar o predecir
            aspectos personales relacionados con su situación económica, salud,
            preferencias personales, intereses, confiabilidad, comportamiento,
            ubicación o movimientos identificados o identificables. Sin embargo,
            TKC no utiliza Datos personales para fines de elaboración de
            perfiles, incluidos los Datos personales de menores de 18 años.
          </p>
          <li>
            <strong>Ejercicio de sus derechos de la CTDPA</strong>
          </li>
          <p>
            Si es residente de Connecticut y desea presentar una solicitud de la
            CTDPA, puede:
          </p>
          <ol>
            <li> Contactarnos por teléfono al 1-844-475-7190, o</li>
            <li>
              
              Iniciar una solicitud completando nuestro formulario en línea que
              se puede encontrar aquí
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Ejerza sus derechos</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Desarrollado por</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
  <p>
            Tenga en cuenta que estos derechos se aplican solo a consumidores
            seleccionados de Connecticut y actualmente excluyen a solicitantes
            de empleo, empleados y contactos comerciales. Solo usted podrá
            realizar una solicitud de consumidor verificable relacionada con sus
            Datos personales. Si se rechaza su solicitud, se le proporcionará un
            método para apelar este hallazgo.
          </p>
</ul>
<h3>Derechos de privacidad de Utah</h3> <p>
          Si es residente de Utah, la Ley de Privacidad del Consumidor de Utah
          (UCPA) le otorga ciertos derechos de privacidad adicionales
          relacionados con los datos personales que TKC recopila sobre usted.
          Consulte a continuación para obtener más información sobre sus
          derechos según la UCPA.
        </p>
        <ul>
          <li>
            <strong>Solicitud de acceso</strong>
          </li>
          <p>
            Tiene derecho a confirmar si TKC está procesando o no sus Datos
            personales. También tiene derecho a acceder a sus Datos personales
            procesados por TKC. No puede solicitar más de dos veces en un
            período de doce (12) meses, de forma gratuita, que le proporcionemos
            acceso fácil y portátil a todos los Datos personales en poder de
            TKC, sujeto a la verificación de su identidad y a las excepciones
            previstas por la ley.
          </p>
          <li>
            <strong>Solicitud de eliminación</strong>
          </li>
          <p>
            Puede solicitar que eliminemos la Información personal que hemos
            recopilado de usted, sujeto a la verificación de su identidad. Tenga
            en cuenta que es posible que cierta información no sea elegible para
            su eliminación según la ley aplicable o los requisitos de los
            contratos de los clientes.
          </p>
          <li>
            <strong>
              Solicitud de no procesar Datos personales para publicidad dirigida
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que no se procesen sus datos personales
            con fines de publicidad dirigida. Sin embargo, TKC no utiliza Datos
            personales con fines de publicidad dirigida.
          </p>
          <li>
            <strong>Solicitud de no vender datos personales</strong>
          </li>
          <p>
            Tiene derecho a optar por que no se vendan sus Datos personales a
            terceros. Sin embargo, TKC no vende Datos personales.
          </p>
          <li>
            <strong>Ejercicio de sus derechos de la UCPA</strong>
          </li>
          <p>
            Si es residente de Utah y desea presentar una solicitud de la UCPA,
            puede:
          </p>
          <ol>
            <li> Contactarnos por teléfono al 1-844-475-7190, o</li>
            <li>
              
              Iniciar una solicitud completando nuestro formulario en línea que
              se puede encontrar aquí
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Ejerza sus derechos</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Desarrollado por</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
   <p>
            Tenga en cuenta que estos derechos se aplican solo a consumidores
            seleccionados de Utah y actualmente excluyen a solicitantes de
            empleo, empleados y contactos comerciales. Solo usted, o un agente
            que usted autorice para actuar en su nombre, puede realizar una
            solicitud de consumidor verificable relacionada con sus Datos
            personales.
          </p>
        </ul>
<h3>Derechos de privacidad de Virginia</h3>
<p>
          Si es residente de Virginia, la Ley de Protección de Datos del
          Consumidor de Virginia (VCDPA) le otorga ciertos derechos de
          privacidad adicionales relacionados con los datos personales que TKC
          recopila sobre usted. Consulte a continuación para obtener más
          información sobre sus derechos según la VCDPA.
        </p>
        <ul>
          <li>
            <strong>Solicitud de acceso</strong>
          </li>
          <p>
            Tiene derecho a confirmar si TKC está procesando o no sus Datos
            personales. También tiene derecho a acceder a sus Datos personales
            procesados por TKC. No puede solicitar más de dos veces al año, de
            forma gratuita, que le proporcionemos acceso fácil y portátil a
            todos los Datos personales en poder de TKC, sujeto a la verificación
            de su identidad y a las excepciones previstas por la ley.
          </p>
          <li>
            <strong>Solicitud de corrección</strong>
          </li>
          <p>
            Puede solicitar que corrijamos los Datos personales inexactos que
            hemos recopilado de usted, sujeto a la verificación de su identidad
            y las excepciones previstas por la ley.
          </p>
          <li>
            <strong>Solicitud de eliminación</strong>
          </li>
          <p>
            Puede solicitar que eliminemos la Información personal que hemos
            recopilado de usted, sujeto a la verificación de su identidad. Tenga
            en cuenta que es posible que cierta información no sea elegible para
            su eliminación según la ley aplicable o los requisitos de los
            contratos de los clientes.
          </p>
          <li>
            <strong>
              Solicitud de no procesar Datos personales para publicidad dirigida
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que no se procesen sus datos personales
            con fines de publicidad dirigida. Sin embargo, TKC no utiliza Datos
            personales con fines de publicidad dirigida.
          </p>
          <li>
            <strong>Solicitud de no vender datos personales</strong>
          </li>
          <p>
            Tiene derecho a optar por que no se vendan sus Datos personales a
            terceros. Sin embargo, TKC no vende Datos personales, incluidos los
            Datos personales de niños menores de 13 años.
          </p>
          <li>
            <strong>
              Solicitud de no crear un perfil basado en Datos personales
            </strong>
          </li>
          <p>
            Tiene derecho a optar por que sus Datos personales no se utilicen
            para procesamiento automatizado para evaluar, analizar o predecir
            aspectos personales relacionados con su situación económica, salud,
            preferencias personales, intereses, confiabilidad, comportamiento,
            ubicación o movimientos identificados o identificables. Sin embargo,
            TKC no utiliza Datos personales para fines de elaboración de
            perfiles.
          </p>
          <li>
            <strong>Ejercicio de sus derechos de la VCDPA</strong>
          </li>
          <p>
            Si es residente de Virginia y desea presentar una solicitud de la
            VCDPA, puede:
          </p>
          <ol>
            <li> Contactarnos por teléfono al 1-844-475-7190, o</li>
            <li>
              
              Iniciar una solicitud completando nuestro formulario en línea que
              se puede encontrar aquí
            </li>
          </ol>
  <a class="ot-btn-anchor"
      href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
      <button type="button" class="ot-exercise-button ot-exercise-button-light">
          <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
          <span class="ot-text-container">Ejerza sus derechos</br>
              <span class="ot-subtext">
                  <span class="ot-powered-by-text">Desarrollado por</span>
                  <span class="onetrust-text">OneTrust</span>
              </span>
          </span>
      </button>
  </a>
  <p>
            Tenga en cuenta que estos derechos se aplican solo a consumidores
            seleccionados de Virginia y actualmente excluyen a solicitantes de
            empleo, empleados y contactos comerciales. Solo usted podrá realizar
            una solicitud de consumidor verificable relacionada con sus Datos
            personales. Si se rechaza su solicitud, se le proporcionará un
            método para apelar este hallazgo.
          </p>
        </ul>

<h3>¿Cuáles son mis derechos a la no discriminación?</h3>
 <p>
          No lo discriminaremos por ejercer cualquiera de sus derechos de la
          CCPA, CPA, CTDPA, UCPA o VCDPA, lo que significa que no:
        </p>
        <ul>
          <li>Le negaremos bienes o servicios.</li>
          <li>
            Le cobraremos precios o tarifas diferentes por bienes o servicios,
            incluso mediante la concesión de descuentos u otros beneficios, o la
            imposición de sanciones.
          </li>
          <li>
            Le proporcionaremos un nivel o calidad diferente de bienes o
            servicios.
          </li>
          <li>
            Le proporcionaremos un nivel o calidad diferente de bienes o
            servicios.
          </li>
        </ul>

<h3>¿Cómo se verificará mi identidad si hago una solicitud?</h3>
<p>
          La solicitud verificable del consumidor debe:
        </p>
        <ul>
          <li>
            Incluir su nombre legal completo, correo electrónico y dirección de
            facturación.
          </li>
          <li>
            Describir su solicitud con suficiente detalle para que nos permita
            comprenderla, evaluarla y responderla adecuadamente.
          </li>
          <li>
            Si realiza la solicitud como agente autorizado, también debe
            proporcionar el nombre legal completo de la parte para la cual
            realiza la solicitud y la documentación en la que se basa su
            autorización.
          </li>
          <p>
            Utilizaremos esta información para verificar su identidad utilizando
            métodos razonables para procesar su solicitud de derechos. Estos
            métodos pueden incluir comparar la información que usted nos
            proporcionó con la información que ya mantenemos nosotros o mediante
            el uso de un servicio de verificación de identidad de terceros.
            Dependiendo de la naturaleza de la solicitud, es posible que
            solicitemos que se tomen medidas de verificación adicionales, que
            incluyen, entre otras, proporcionar una declaración firmada bajo
            pena de perjurio de que usted es el consumidor cuya información o
            datos personales son el tema de la solicitud.
          </p>
          <p>
            Utilizaremos la información que usted proporcione para verificar su
            identidad y responder a su solicitud de derechos y para ningún otro
            propósito.
          </p>
          <p>
            No podemos responder a su solicitud ni proporcionarle Información o
            Datos personales si no podemos verificar su identidad o autoridad
            para realizar la solicitud o confirmar la Información o Datos
            personales relacionados con usted.
          </p>
          <p>
            No es necesario que tenga una cuenta con nosotros para realizar una
            solicitud verificable.
          </p>
        </ul>
<h3>Privacidad de los niños </h3>
<p>
   Este sitio web no está dirigido a niños menores de 13 años, ni
          recopilamos conscientemente Información ni Datos personales de ellos.
          Los niños que deseen realizar compras a través de nuestros servicios
          deben hacerlo con la participación de un padre/madre o tutor.
</p>
<h3>Cambios a la Política</h3>
<p>
          Podemos actualizar la política de privacidad según sea necesario para
          reflejar los cambios de nuestros negocios y servicios. Publicaremos
          los cambios a la Política de privacidad en nuestro sitio web, con la
          fecha de entrada en vigencia de las revisiones destacada junto a la
          fecha de “Última modificación y fecha de entrada en vigencia”. Le
          pedimos que revise la política de privacidad con frecuencia para ver
          los cambios realizados. Si realizamos un cambio sustancial en la
          Política de privacidad, le proporcionaremos el aviso correspondiente
          (como agregar una declaración a nuestra página de inicio o enviarle
          una notificación por correo electrónico).
        </p>
<h3> Cómo actualizar su información y gestionar las comunicaciones</h3>
<p>
          Si desea modificar su información de registro, por ingrese a su cuenta
          y haga los cambios necesarios. Al momento de registrarse, podemos
          darle la opción de elegir si desea recibir información sobre nuevas
          funciones, ofertas u otros avisos relacionados con TKC y sus
          servicios. Cuando se registra, puede optar por no recibir estas
          comunicaciones al no hacer clic en una casilla que nos permita
          enviarle dicha información. Usted también tiene la opción cambiar esta
          opción siguiendo las instrucciones de nuestro comunicado.
        </p>
        <p>
          Si no es residente de California o Virginia y desea:
        </p>
        <ul>
          <li>Determinar qué datos, si los hay, tenemos de usted</li>
          <li>Recibir una copia de cualquier dato que poseamos sobre usted</li>
          <li>
            Hacer que todos los datos suyos que tengamos sean eliminados,
            corregidos o modificados
          </li>
        </ul>
<p> Puede comunicarse con nosotros por correo electrónico <a class="ot-btn-anchor" href="mailto:privacy@tkcholdings.com" target="_blank">en este enlace</a> para
          dichas solicitudes. Su solicitud debe identificarlo adecuadamente con
          su nombre legal completo, correo electrónico y dirección de
          facturación. Su solicitud debe describirse con suficiente detalle que
          nos permita comprenderla, evaluarla y responderla adecuadamente.</p>

<h3>Contacto para obtener más información</h3>
<p>
  Sus preguntas y comentarios sobre nuestra política de privacidad son
          bienvenidos. Dirija las comunicaciones a TKC por correo electrónico
  <a class="ot-btn-anchor" href="mailto:privacy@tkcholdings.com" target="_blank">aquí</a>.
</p>

<h3><u>Aviso de privacidad para empleados de California</u></h3>
<ul>
          <p>
            <strong>
              <u>¿Cuál es el propósito de este aviso?</u>
            </strong>
          </p>
          <p>
            Este Aviso de privacidad para empleados de California (el "Aviso")
            describe la recopilación de Información personal e Información
            personal confidencial por parte de TKC de solicitantes de empleo,
            empleados y contratistas, los fines comerciales para los cuales se
            utilizarán estos datos y los derechos de privacidad de los
            solicitantes, empleados, contratistas, beneficiarios, contactos de
            emergencia y miembros de la junta directiva de California. Este
            Aviso complementa cualquier otro aviso de privacidad y no pretende
            anularlo. Esto incluye, entre otras, las disposiciones del Manual
            del empleado.
          </p>
          <p>
            Solicitante de empleo: una persona que busca empleo en TKC mediante
            la creación de un perfil en línea y la presentación de una solicitud
            de empleo completa a través del Sitio de carreras de TKC en <a class="ot-btn-anchor" href="https://careers.tkcholdings.com/why-us"
          target="_blank">https://careers.tkcholdings.com/why-us</a>. </p>
  <p>Empleado: cualquier persona contratada por un sueldo, salario,
            tarifa o pago pagado por TKC para trabajar bajo la supervisión y
            control de TKC. </p>
   <p>
            Contratista: cualquier persona remunerada por realizar un trabajo o
            servicio específico bajo un contrato con TKC. Las personas colocadas
            por una agencia de empleo de terceros para realizar trabajos
            temporales en beneficio de TKC pero que son compensadas por esa
            agencia de empleo de terceros no son empleados ni contratistas de
            TKC; dichas personas son empleadas por la agencia de personal de
            terceros, no por TKC.
          </p>

          <p>
            <strong>
              <u>Categorías de Información personal recopilada</u>
            </strong>
          </p>
          <p>
            TKC recopila Información personal e Información personal
            confidencial sobre usted durante el proceso de solicitud y durante
            todo el ámbito de su empleo con TKC.
          </p>
          <p>
            Las categorías de Información personal e Información personal
            confidencial recopiladas pueden incluir lo siguiente:
          </p>
          <ul>
            <li>
              <strong>Identificadores</strong>, como nombre, alias, dirección
              postal, identificador personal único, identificador en línea,
              dirección de Protocolo de Internet (IP), dirección de correo
              electrónico, nombre de cuenta, número de seguro social, número de
              licencia de conducir, número de pasaporte u otros identificadores
              similares.
            </li>
            <li>
              <strong>
                Características de las clasificaciones protegidas según la ley
                federal o de California,
              </strong>
              incluida la edad o fecha de nacimiento, origen nacional,
              discapacidad, ciudadanía, estado militar.
            </li>
            <li>
              <strong>Información biométrica</strong>, incluido el color de
              cabello, color de ojos, huellas dactilares, altura, exploración de
              retina, reconocimiento facial, voz y otros datos biométricos.
            </li>
            <li>
              <strong>
                Información sobre la actividad de Internet u otras redes
                electrónicas,
              </strong>
              incluido el historial de navegación, el historial de búsqueda y
              la información sobre la interacción de un consumidor con un sitio
              web, una aplicación o un anuncio de Internet.
            </li>
            <li>
              <strong>Datos de geolocalización</strong>, que incluyen cualquier
              tipo de dato que permita determinar, con precisión razonable, su
              ubicación.
            </li>
            <li>
              <strong>
                Información profesional o relacionada con el empleo.
              </strong>
            </li>
            <li>
              <strong>Información sobre educación.</strong>
            </li>
            <li>
              <strong>
                Inferencias extraídas de cualquiera de la información
                identificada en esta subdivisión para crear un perfil sobre un
                consumidor que refleje las preferencias, características,
                tendencias psicológicas, predisposiciones, comportamiento,
                actitudes, inteligencia, habilidades y aptitudes del consumidor.
              </strong>
            </li>
            <li>
              <strong>
                Información personal que revele su número de seguro social,
                licencia de conducir, tarjeta de identificación estatal o
                pasaporte.
              </strong>
            </li>
            <li>
              <strong>
                Información personal recopilada y analizada sobre la salud del
                consumidor.
              </strong>
            </li>
          </ul>
 <p>
            TKC no utiliza ni divulga información personal confidencial para
            fines distintos de los especificados en la sección 7027(m) de las
            regulaciones de la CCPA.
          </p>

          <p>
            <strong>
              <u>Propósito comercial</u>
            </strong>
          </p>
          <p>
            TKC utiliza Información Personal e Información Personal Sensible,
            para todos los fines relacionados con la solicitud de empleo y la
            creación, administración y terminación de su relación laboral con
            TKC y para todos los fines relacionados con los clientes. Estos
            propósitos incluyen, entre otros, los siguientes:
          </p>
          <ul>
            <li>Tomar una decisión sobre su reclutamiento o nombramiento</li>
            <li>
              Evaluar sus habilidades, cualificaciones e idoneidad para el
              trabajo o puesto para el que se postula
            </li>
            <li>
              Realizar verificaciones de antecedentes y referencias, cuando
              corresponda
            </li>
            <li>Comunicarnos con usted sobre el proceso de reclutamiento</li>
            <li>Determinar los términos en los que trabaja para nosotros</li>
            <li>
              Confirmar que tiene derecho legal a trabajar en los Estados Unidos
            </li>
            <li>
              Administrar la compensación, incluido, entre otros, el pago de
              salarios y bonificaciones y la retención del impuesto sobre la
              renta y el reembolso de gastos comerciales
            </li>
            <li>
              Proporcionarle beneficios laborales, si corresponde, por ejemplo,
              seguro médico, seguro de vida y planes de ahorro para la
              jubilación
            </li>
            <li>
              Gestión y planificación empresarial, incluidas contabilidad y
              auditoría
            </li>
            <li>
              Realizar revisiones de desempeño, gestionar el desempeño y
              determinar los requisitos de desempeño
            </li>
            <li>
              Tomar decisiones sobre revisiones salariales y compensaciones
            </li>
            <li>
              Evaluar las calificaciones para un trabajo o tarea en particular,
              incluidas decisiones sobre ascensos
            </li>
            <li>
              Recopilar pruebas para posibles quejas o audiencias disciplinarias
            </li>
            <li>Tomar decisiones sobre su empleo o compromiso continuo</li>
            <li>
              Tomar medidas para la terminación de nuestra relación laboral
            </li>
            <li>Requisitos de formación, capacitación y desarrollo</li>
            <li>
              Tratar litigios legales que lo involucren a usted u otros
              empleados, trabajadores y contratistas, incluidos accidentes de
              trabajo
            </li>
            <li>Determinar su aptitud para el trabajo</li>
            <li>
              Administrar las licencias según lo exige la ley o la política de
              la empresa
            </li>
            <li>Cumplir con las obligaciones de seguridad y salud</li>
            <li>Prevenir el fraude</li>
            <li>
              Monitorear su uso de nuestros sistemas de información y
              comunicación para garantizar el cumplimiento de nuestras políticas
            </li>
            <li>
              Para garantizar la seguridad de la red y de la información,
              incluida la prevención del acceso no autorizado a nuestros
              sistemas informáticos y de comunicaciones electrónicas y la
              prevención de la distribución de software malicioso
            </li>
            <li>
              Realizar estudios de análisis de datos para revisar y comprender
              mejor las tasas de retención y deserción de empleados
            </li>
            <li>Seguimiento de la igualdad de oportunidades</li>
            <li>
              Ejercer los derechos de TKC bajo la ley aplicable y respaldar
              cualquier reclamación, defensa o declaración en un caso o ante una
              autoridad jurisdiccional o administrativa, panel de arbitraje o
              mediación
            </li>
            <li>
              Cumplir con los requisitos legales y regulatorios, incluido el
              descubrimiento civil en litigios que involucran a TKC o compañías
              afiliadas
            </li>
            <li>
              Facilitar las funciones administrativas, incluidas, entre otras,
              la gestión y operación de sistemas de tecnología de la información
              y comunicaciones, gestión de riesgos y funciones de seguros,
              elaboración de presupuestos, gestión e informes financieros,
              planificación estratégica y el mantenimiento de licencias,
              permisos y autorizaciones aplicables a las operaciones comerciales
              de TKC.
            </li>
          </ul>

 <p>
            <strong>
              <u>
                Retención de Información personal e Información personal
                confidencial
              </u>
            </strong>
          </p>
          <p>
            La Información personal y la Información personal confidencial no se
            conservarán por más tiempo del necesario para el propósito comercial
            para el cual se recopila y procesa y se conservará de acuerdo con
            nuestras políticas internas de retención de documentos. En ciertos
            casos, las leyes o regulaciones nos exigen mantener registros
            durante períodos de tiempo específicos, incluso después de la
            terminación de la relación laboral. En otros casos, los registros se
            conservan para administrar la relación laboral o para resolver
            consultas o litigios que surjan de vez en cuando.
          </p>

          <p>
            <strong>
              <u>Derechos de privacidad</u>
            </strong>
          </p>
          <p>
            La Ley de Privacidad del Consumidor de California (CCPA) le brinda
            ciertos derechos de privacidad adicionales relacionados con la
            Información personal y la Información personal confidencial que TKC
            recopila sobre usted. Consulte a continuación para obtener más
            información sobre sus derechos según la CCPA.
          </p>
          <ul>
            <li>
              <strong>Solicitud de información</strong>
            </li>
            <p>
              No puede solicitar información más de dos veces en cualquier
              período de doce (12) meses y, sujeto a la verificación de su
              identidad y ciertas exenciones, le proporcionaremos:
            </p>
            <ol>
              <li>
                Las categorías de Información personal que recopilamos sobre
                usted.
              </li>
              <li>
                Las categorías de fuentes de las que se recopila la Información
                personal.
              </li>
              <li>
                Las categorías de Información personal vendida o compartida con
                fines de publicidad multicontextual a un tercero, así como las
                categorías de terceros a quienes se reveló dicha información
                personal, por categoría de categorías de información personal
                para cada categoría de tercero.
              </li>
              <li>
                Las categorías de Información personal que la empresa reveló
                sobre el consumidor con fines comerciales y las categorías de
                personas a quienes se reveló con fines comerciales.
              </li>
              <li>
                Nuestro propósito comercial o de negocios para recopilar, vender
                o compartir su información personal con fines de publicidad
                multicontextual.
              </li>
              <li>
                Los datos personales específicos que recopilamos sobre usted.
              </li>
            </ol>
            <li>
              <strong>Solicitud de eliminación</strong>
            </li>
            <p>
              Puede solicitar que eliminemos la Información personal que hemos
              recopilado de usted, sujeto a la verificación de su identidad.
              Tenga en cuenta que es posible que cierta información no sea
              elegible para su eliminación según la ley aplicable o los
              requisitos de los contratos.
            </p>

            <li>
              <strong>Solicitud de corrección</strong>
            </li>
            <p>
              Puede solicitar que corrijamos la Información personal y la
              Información personal confidencial inexacta que hemos recopilado de
              usted, sujeto a la verificación de su identidad y las excepciones
              previstas por la ley.
            </p>

            <li>
              <strong>
                Solicitud de no vender ni compartir Información personal e
                Información personal confidencial
              </strong>
            </li>
            <p>
              Tiene derecho a optar por que no se venda su Información personal
              ni su Información personal confidencial a terceros con fines de
              publicidad multicontextual. Sin embargo, TKC no vende Información
              personal o Información confidencial ni TKC comparte Información
              personal o Información personal confidencial con terceros con
              fines de publicidad multicontextual; incluyendo que TKC no tiene
              conocimiento real de ninguna venta de Información personal o
              Información personal confidencial de menores de 16 años.
            </p>

            <li>
              <strong>Solicitud para limitar el uso y la divulgación</strong>
            </li>
            <p>
              Puede solicitar que limitemos el uso y la divulgación de su
              Información personal confidencial.
            </p>
          </ul>
          <p>
            <strong>Ejercicio de sus derechos de la CCPA</strong>
          </p>
          <p>
            Si es residente de California y desea presentar una solicitud de la
            CCPA, usted o su agente autorizado pueden:
          </p>
          <ul>
            <ol>
              <li>Contactarnos por teléfono al 1-844-475-7190, o</li>
              <li>
                
                Iniciar una solicitud completando nuestro formulario en línea
                que se puede encontrar aquí
              </li>
            </ol>
      <a class="ot-btn-anchor"
          href="https://privacyportal.onetrust.com/webform/05c39c21-9080-4d24-80f6-ea3b01f14cdf/878227e9-51ba-4b9c-b26c-c8bc7973c0b7">
          <button type="button" class="ot-exercise-button ot-exercise-button-light">
              <img src="https://cdn.onetrust.com/images/exercise-your-rights-icon.svg">
              <span class="ot-text-container">Ejerza sus derechos</br>
                  <span class="ot-subtext">
                      <span class="ot-powered-by-text">Desarrollado por</span>
                      <span class="onetrust-text">OneTrust</span>
                  </span>
              </span>
          </button>
      </a>
  </ul>
   <p>
            <strong>
              <u>
                ¿Cuáles son mis derechos a la no discriminación según la CCPA?
              </u>
            </strong>
          </p>
          <p>
            No lo discriminaremos ni tomaremos represalias contra usted por
            ejercer cualquiera de sus derechos de la CCPA a recibir un aviso en
            el momento de la recopilación de su Información personal o
            Información personal confidencial, o al presentar un derecho privado
            de acción luego de una violación de datos que involucre su
            Información personal o Información personal confidencial causada por
            una fallo de TKC en mantener salvaguardias razonables.
          </p>

          <p>
            <strong>
              <u>¿Cómo se verificará mi identidad si hago una solicitud?</u>
            </strong>
          </p>
          <p>
            La solicitud verificable debe:
          </p>
          <ul>
            <li>
              Incluir su nombre legal completo, correo electrónico y dirección
              de facturación.
            </li>
            <li>
              Describir su solicitud con suficiente detalle para que nos permita
              comprenderla, evaluarla y responderla adecuadamente.
            </li>
            <li>
              Si realiza la solicitud como agente autorizado, también debe
              proporcionar el nombre legal completo de la parte para la cual
              realiza la solicitud y la documentación en la que se basa su
              autorización.
            </li>
          </ul>

          <p>
            Utilizaremos esta información para verificar su identidad utilizando
            métodos razonables para procesar su solicitud de derechos. Estos
            métodos pueden incluir comparar la información que usted nos
            proporcionó con la información que ya mantenemos nosotros o mediante
            el uso de un servicio de verificación de identidad de terceros.
            Dependiendo de la naturaleza de la solicitud, es posible que
            solicitemos que se tomen medidas de verificación adicionales, que
            incluyen, entre otras, proporcionar una declaración firmada bajo
            pena de perjurio de que usted es el consumidor cuya Información
            personal o Información personal confidencial son el tema de la
            solicitud.
          </p>
          <p>
            Utilizaremos la información que usted proporcione para verificar su
            identidad y responder a su solicitud de derechos y para ningún otro
            propósito.
          </p>
          <p>
            No podemos responder a su solicitud ni proporcionarle Información
            personal o Información personal confidencial si no podemos verificar
            su identidad o autoridad para realizar la solicitud o confirmar la
            Información personal o Información personal confidencial
            relacionados con usted.
          </p>
          <p>
            No es necesario que tenga una cuenta con nosotros para realizar una
            solicitud verificable.
          </p>

          <p>
            <strong>
              <u>Preguntas</u>
            </strong>
          </p>
          <p>
  <p>Si tiene alguna pregunta o inquietud sobre este Aviso, haga clic<a class="ot-btn-anchor" href="mailto:privacy@tkcholdings.com"
          target="_blank"> aquí para enviar un correo electrónico</a>.</p>

</ul>`,
};

export const DeleteSavedCard = (last4: string): DialogChildren => {
  return {
    open: true,
    title: "DELETE CARD",
    subtitle: "",
    content: `
  <p style="text-align: center" class='dialogContentWarning'>This action cannot be undone.</p>
  <p>Are you sure you want to delete card ending in ****${last4}?</p>`,
    cancelButton: { color: "primary", caption: "CANCEL" },
    affirmativeButton: { color: "primary", caption: "DELETE" },
  };
};

export const ReactivateAccountDialog: DialogChildren = {
  open: true,
  title: "REACTIVATE ACCOUNT",
  subtitle: "",
  content: `<p id="replaceId"></p>`,
  affirmativeButton: { color: "secondary", variant: "text", caption: "" },
};

export const NewEmailRequiredDialog: DialogChildren = {
  open: true,
  title: "NOTICE",
  subtitle: "",
  content: `<p style="text-align: center" class='dialogContentWarning' id="replaceId">New email required.</p>
  <p>To create a new account, you must use an email that has not been previously used in our system.</p>`,
  cancelButton: { color: "primary", caption: "CANCEL" },
  affirmativeButton: { color: "primary", caption: "OK" },
};

export const LanguageDetectionDialog: DialogChildren = {
  open: true,
  title: "NOTICE:",
  subtitle: "",
  content: `<p>We have detected that you have language translation turned on. Please note that our legal pages are only available in English or Spanish. We apologize for any inconvenience this may cause.</p>`,
  affirmativeButton: { color: "primary", caption: "OK" },
};
